!(function (t, e) {
    "object" == typeof exports && "object" == typeof module ? (module.exports = e()) : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? (exports.Handlebars = e()) : (t.Handlebars = e());
})(this, function () {
    return (function (i) {
        function s(t) {
            if (o[t]) return o[t].exports;
            var e = (o[t] = { exports: {}, id: t, loaded: !1 });
            return i[t].call(e.exports, e, e.exports, s), (e.loaded = !0), e.exports;
        }
        var o = {};
        return (s.m = i), (s.c = o), (s.p = ""), s(0);
    })([
        function (t, e, i) {
            "use strict";
            function s() {
                var i = h();
                return (
                    (i.compile = function (t, e) {
                        return l.compile(t, e, i);
                    }),
                    (i.precompile = function (t, e) {
                        return l.precompile(t, e, i);
                    }),
                    (i.AST = r.default),
                    (i.Compiler = l.Compiler),
                    (i.JavaScriptCompiler = c.default),
                    (i.Parser = a.parser),
                    (i.parse = a.parse),
                    i
                );
            }
            var o = i(1).default;
            e.__esModule = !0;
            var n = o(i(2)),
                r = o(i(21)),
                a = i(22),
                l = i(27),
                c = o(i(28)),
                p = o(i(25)),
                d = o(i(20)),
                h = n.default.create,
                u = s();
            (u.create = s), d.default(u), (u.Visitor = p.default), (u.default = u), (e.default = u), (t.exports = e.default);
        },
        function (t, e) {
            "use strict";
            (e.default = function (t) {
                return t && t.__esModule ? t : { default: t };
            }),
                (e.__esModule = !0);
        },
        function (t, e, i) {
            "use strict";
            function s() {
                var e = new r.HandlebarsEnvironment();
                return (
                    c.extend(e, r),
                    (e.SafeString = a.default),
                    (e.Exception = l.default),
                    (e.Utils = c),
                    (e.escapeExpression = c.escapeExpression),
                    (e.VM = p),
                    (e.template = function (t) {
                        return p.template(t, e);
                    }),
                    e
                );
            }
            var o = i(3).default,
                n = i(1).default;
            e.__esModule = !0;
            var r = o(i(4)),
                a = n(i(18)),
                l = n(i(6)),
                c = o(i(5)),
                p = o(i(19)),
                d = n(i(20)),
                h = s();
            (h.create = s), d.default(h), (h.default = h), (e.default = h), (t.exports = e.default);
        },
        function (t, e) {
            "use strict";
            (e.default = function (t) {
                if (t && t.__esModule) return t;
                var e = {};
                if (null != t) for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                return (e.default = t), e;
            }),
                (e.__esModule = !0);
        },
        function (t, e, i) {
            "use strict";
            function s(t, e, i) {
                (this.helpers = t || {}), (this.partials = e || {}), (this.decorators = i || {}), a.registerDefaultHelpers(this), l.registerDefaultDecorators(this);
            }
            var o = i(1).default;
            (e.__esModule = !0), (e.HandlebarsEnvironment = s);
            var n = i(5),
                r = o(i(6)),
                a = i(7),
                l = i(15),
                c = o(i(17));
            (e.VERSION = "4.0.5"), (e.COMPILER_REVISION = 7), (e.REVISION_CHANGES = { 1: "<= 1.0.rc.2", 2: "== 1.0.0-rc.3", 3: "== 1.0.0-rc.4", 4: "== 1.x.x", 5: "== 2.0.0-alpha.x", 6: ">= 2.0.0-beta.1", 7: ">= 4.0.0" });
            var p = "[object Object]";
            s.prototype = {
                constructor: s,
                logger: c.default,
                log: c.default.log,
                registerHelper: function (t, e) {
                    if (n.toString.call(t) === p) {
                        if (e) throw new r.default("Arg not supported with multiple helpers");
                        n.extend(this.helpers, t);
                    } else this.helpers[t] = e;
                },
                unregisterHelper: function (t) {
                    delete this.helpers[t];
                },
                registerPartial: function (t, e) {
                    if (n.toString.call(t) === p) n.extend(this.partials, t);
                    else {
                        if (void 0 === e) throw new r.default('Attempting to register a partial called "' + t + '" as undefined');
                        this.partials[t] = e;
                    }
                },
                unregisterPartial: function (t) {
                    delete this.partials[t];
                },
                registerDecorator: function (t, e) {
                    if (n.toString.call(t) === p) {
                        if (e) throw new r.default("Arg not supported with multiple decorators");
                        n.extend(this.decorators, t);
                    } else this.decorators[t] = e;
                },
                unregisterDecorator: function (t) {
                    delete this.decorators[t];
                },
            };
            var d = c.default.log;
            (e.log = d), (e.createFrame = n.createFrame), (e.logger = c.default);
        },
        function (t, e) {
            "use strict";
            function i(t) {
                return o[t];
            }
            function s(t) {
                for (var e = 1; e < arguments.length; e++) for (var i in arguments[e]) Object.prototype.hasOwnProperty.call(arguments[e], i) && (t[i] = arguments[e][i]);
                return t;
            }
            (e.__esModule = !0),
                (e.extend = s),
                (e.indexOf = function (t, e) {
                    for (var i = 0, s = t.length; i < s; i++) if (t[i] === e) return i;
                    return -1;
                }),
                (e.escapeExpression = function (t) {
                    if ("string" != typeof t) {
                        if (t && t.toHTML) return t.toHTML();
                        if (null == t) return "";
                        if (!t) return t + "";
                        t = "" + t;
                    }
                    return r.test(t) ? t.replace(n, i) : t;
                }),
                (e.isEmpty = function (t) {
                    return (!t && 0 !== t) || !(!c(t) || 0 !== t.length);
                }),
                (e.createFrame = function (t) {
                    var e = s({}, t);
                    return (e._parent = t), e;
                }),
                (e.blockParams = function (t, e) {
                    return (t.path = e), t;
                }),
                (e.appendContextPath = function (t, e) {
                    return (t ? t + "." : "") + e;
                });
            var o = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#x27;", "`": "&#x60;", "=": "&#x3D;" },
                n = /[&<>"'`=]/g,
                r = /[&<>"'`=]/,
                a = Object.prototype.toString;
            e.toString = a;
            var l = function (t) {
                return "function" == typeof t;
            };
            l(/x/) &&
                (e.isFunction = l = function (t) {
                    return "function" == typeof t && "[object Function]" === a.call(t);
                }),
                (e.isFunction = l);
            var c =
                Array.isArray ||
                function (t) {
                    return !(!t || "object" != typeof t) && "[object Array]" === a.call(t);
                };
            e.isArray = c;
        },
        function (t, e) {
            "use strict";
            function a(t, e) {
                var i = e && e.loc,
                    s = void 0,
                    o = void 0;
                i && (t += " - " + (s = i.start.line) + ":" + (o = i.start.column));
                for (var n = Error.prototype.constructor.call(this, t), r = 0; r < l.length; r++) this[l[r]] = n[l[r]];
                Error.captureStackTrace && Error.captureStackTrace(this, a), i && ((this.lineNumber = s), (this.column = o));
            }
            e.__esModule = !0;
            var l = ["description", "fileName", "lineNumber", "message", "name", "number", "stack"];
            (a.prototype = new Error()), (e.default = a), (t.exports = e.default);
        },
        function (t, e, i) {
            "use strict";
            var s = i(1).default;
            (e.__esModule = !0),
                (e.registerDefaultHelpers = function (t) {
                    o.default(t), n.default(t), r.default(t), a.default(t), l.default(t), c.default(t), p.default(t);
                });
            var o = s(i(8)),
                n = s(i(9)),
                r = s(i(10)),
                a = s(i(11)),
                l = s(i(12)),
                c = s(i(13)),
                p = s(i(14));
        },
        function (t, e, i) {
            "use strict";
            e.__esModule = !0;
            var r = i(5);
            (e.default = function (n) {
                n.registerHelper("blockHelperMissing", function (t, e) {
                    var i = e.inverse,
                        s = e.fn;
                    if (!0 === t) return s(this);
                    if (!1 === t || null == t) return i(this);
                    if (r.isArray(t)) return 0 < t.length ? (e.ids && (e.ids = [e.name]), n.helpers.each(t, e)) : i(this);
                    if (e.data && e.ids) {
                        var o = r.createFrame(e.data);
                        (o.contextPath = r.appendContextPath(e.data.contextPath, e.name)), (e = { data: o });
                    }
                    return s(t, e);
                });
            }),
                (t.exports = e.default);
        },
        function (t, e, i) {
            "use strict";
            var s = i(1).default;
            e.__esModule = !0;
            var h = i(5),
                u = s(i(6));
            (e.default = function (t) {
                t.registerHelper("each", function (s, t) {
                    function e(t, e, i) {
                        a && ((a.key = t), (a.index = e), (a.first = 0 === e), (a.last = !!i), l && (a.contextPath = l + t)), (r += o(s[t], { data: a, blockParams: h.blockParams([s[t], t], [l + t, null]) }));
                    }
                    if (!t) throw new u.default("Must pass iterator to #each");
                    var o = t.fn,
                        i = t.inverse,
                        n = 0,
                        r = "",
                        a = void 0,
                        l = void 0;
                    if ((t.data && t.ids && (l = h.appendContextPath(t.data.contextPath, t.ids[0]) + "."), h.isFunction(s) && (s = s.call(this)), t.data && (a = h.createFrame(t.data)), s && "object" == typeof s))
                        if (h.isArray(s)) for (var c = s.length; n < c; n++) n in s && e(n, n, n === s.length - 1);
                        else {
                            var p = void 0;
                            for (var d in s) s.hasOwnProperty(d) && (void 0 !== p && e(p, n - 1), (p = d), n++);
                            void 0 !== p && e(p, n - 1, !0);
                        }
                    return 0 === n && (r = i(this)), r;
                });
            }),
                (t.exports = e.default);
        },
        function (t, e, i) {
            "use strict";
            var s = i(1).default;
            e.__esModule = !0;
            var o = s(i(6));
            (e.default = function (t) {
                t.registerHelper("helperMissing", function () {
                    if (1 !== arguments.length) throw new o.default('Missing helper: "' + arguments[arguments.length - 1].name + '"');
                });
            }),
                (t.exports = e.default);
        },
        function (t, e, i) {
            "use strict";
            e.__esModule = !0;
            var s = i(5);
            (e.default = function (i) {
                i.registerHelper("if", function (t, e) {
                    return s.isFunction(t) && (t = t.call(this)), (!e.hash.includeZero && !t) || s.isEmpty(t) ? e.inverse(this) : e.fn(this);
                }),
                    i.registerHelper("unless", function (t, e) {
                        return i.helpers.if.call(this, t, { fn: e.inverse, inverse: e.fn, hash: e.hash });
                    });
            }),
                (t.exports = e.default);
        },
        function (t, e) {
            "use strict";
            (e.__esModule = !0),
                (e.default = function (o) {
                    o.registerHelper("log", function () {
                        for (var t = [void 0], e = arguments[arguments.length - 1], i = 0; i < arguments.length - 1; i++) t.push(arguments[i]);
                        var s = 1;
                        null != e.hash.level ? (s = e.hash.level) : e.data && null != e.data.level && (s = e.data.level), (t[0] = s), o.log.apply(o, t);
                    });
                }),
                (t.exports = e.default);
        },
        function (t, e) {
            "use strict";
            (e.__esModule = !0),
                (e.default = function (t) {
                    t.registerHelper("lookup", function (t, e) {
                        return t && t[e];
                    });
                }),
                (t.exports = e.default);
        },
        function (t, e, i) {
            "use strict";
            e.__esModule = !0;
            var o = i(5);
            (e.default = function (t) {
                t.registerHelper("with", function (t, e) {
                    o.isFunction(t) && (t = t.call(this));
                    var i = e.fn;
                    if (o.isEmpty(t)) return e.inverse(this);
                    var s = e.data;
                    return e.data && e.ids && ((s = o.createFrame(e.data)).contextPath = o.appendContextPath(e.data.contextPath, e.ids[0])), i(t, { data: s, blockParams: o.blockParams([t], [s && s.contextPath]) });
                });
            }),
                (t.exports = e.default);
        },
        function (t, e, i) {
            "use strict";
            var s = i(1).default;
            (e.__esModule = !0),
                (e.registerDefaultDecorators = function (t) {
                    o.default(t);
                });
            var o = s(i(16));
        },
        function (t, e, i) {
            "use strict";
            e.__esModule = !0;
            var a = i(5);
            (e.default = function (t) {
                t.registerDecorator("inline", function (o, n, r, t) {
                    var e = o;
                    return (
                        n.partials ||
                            ((n.partials = {}),
                            (e = function (t, e) {
                                var i = r.partials;
                                r.partials = a.extend({}, i, n.partials);
                                var s = o(t, e);
                                return (r.partials = i), s;
                            })),
                        (n.partials[t.args[0]] = t.fn),
                        e
                    );
                });
            }),
                (t.exports = e.default);
        },
        function (t, e, i) {
            "use strict";
            e.__esModule = !0;
            var s = i(5),
                n = {
                    methodMap: ["debug", "info", "warn", "error"],
                    level: "info",
                    lookupLevel: function (t) {
                        if ("string" == typeof t) {
                            var e = s.indexOf(n.methodMap, t.toLowerCase());
                            t = 0 <= e ? e : parseInt(t, 10);
                        }
                        return t;
                    },
                    log: function (t) {
                        if (((t = n.lookupLevel(t)), "undefined" != typeof console && n.lookupLevel(n.level) <= t)) {
                            var e = n.methodMap[t];
                            console[e] || (e = "log");
                            for (var i = arguments.length, s = Array(1 < i ? i - 1 : 0), o = 1; o < i; o++) s[o - 1] = arguments[o];
                            console[e].apply(console, s);
                        }
                    },
                };
            (e.default = n), (t.exports = e.default);
        },
        function (t, e) {
            "use strict";
            function i(t) {
                this.string = t;
            }
            (e.__esModule = !0),
                (i.prototype.toString = i.prototype.toHTML = function () {
                    return "" + this.string;
                }),
                (e.default = i),
                (t.exports = e.default);
        },
        function (t, e, i) {
            "use strict";
            function d(s, t, o, n, e, r, a) {
                function i(t) {
                    var e = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
                        i = a;
                    return a && t !== a[0] && (i = [t].concat(a)), o(s, t, s.helpers, s.partials, e.data || n, r && [e.blockParams].concat(r), i);
                }
                return ((i = h(o, i, s, a, n, r)).program = t), (i.depth = a ? a.length : 0), (i.blockParams = e || 0), i;
            }
            function o() {
                return "";
            }
            function h(t, e, i, s, o, n) {
                if (t.decorator) {
                    var r = {};
                    (e = t.decorator(e, r, i, s && s[0], o, n, s)), u.extend(e, r);
                }
                return e;
            }
            var s = i(3).default,
                n = i(1).default;
            (e.__esModule = !0),
                (e.checkRevision = function (t) {
                    var e = (t && t[0]) || 1,
                        i = m.COMPILER_REVISION;
                    if (e !== i) {
                        if (e < i) {
                            var s = m.REVISION_CHANGES[i],
                                o = m.REVISION_CHANGES[e];
                            throw new f.default(
                                "Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" +
                                    s +
                                    ") or downgrade your runtime to an older version (" +
                                    o +
                                    ")."
                            );
                        }
                        throw new f.default("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + t[1] + ").");
                    }
                }),
                (e.template = function (l, a) {
                    function c(t) {
                        function e(t) {
                            return "" + l.main(p, t, p.helpers, p.partials, n, a, r);
                        }
                        var i,
                            s,
                            o = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
                            n = o.data;
                        c._setup(o), !o.partial && l.useData && ((i = t), ((s = n) && "root" in s) || ((s = s ? m.createFrame(s) : {}).root = i), (n = s));
                        var r = void 0,
                            a = l.useBlockParams ? [] : void 0;
                        return l.useDepths && (r = o.depths ? (t !== o.depths[0] ? [t].concat(o.depths) : o.depths) : [t]), (e = h(l.main, e, p, o.depths || [], n, a))(t, o);
                    }
                    if (!a) throw new f.default("No environment passed to template");
                    if (!l || !l.main) throw new f.default("Unknown template object: " + typeof l);
                    (l.main.decorator = l.main_d), a.VM.checkRevision(l.compiler);
                    var p = {
                        strict: function (t, e) {
                            if (!(e in t)) throw new f.default('"' + e + '" not defined in ' + t);
                            return t[e];
                        },
                        lookup: function (t, e) {
                            for (var i = t.length, s = 0; s < i; s++) if (t[s] && null != t[s][e]) return t[s][e];
                        },
                        lambda: function (t, e) {
                            return "function" == typeof t ? t.call(e) : t;
                        },
                        escapeExpression: u.escapeExpression,
                        invokePartial: function (t, e, i) {
                            i.hash && ((e = u.extend({}, e, i.hash)), i.ids && (i.ids[0] = !0)), (t = a.VM.resolvePartial.call(this, t, e, i));
                            var s = a.VM.invokePartial.call(this, t, e, i);
                            if ((null == s && a.compile && ((i.partials[i.name] = a.compile(t, l.compilerOptions, a)), (s = i.partials[i.name](e, i))), null != s)) {
                                if (i.indent) {
                                    for (var o = s.split("\n"), n = 0, r = o.length; n < r && (o[n] || n + 1 !== r); n++) o[n] = i.indent + o[n];
                                    s = o.join("\n");
                                }
                                return s;
                            }
                            throw new f.default("The partial " + i.name + " could not be compiled when running in runtime-only mode");
                        },
                        fn: function (t) {
                            var e = l[t];
                            return (e.decorator = l[t + "_d"]), e;
                        },
                        programs: [],
                        program: function (t, e, i, s, o) {
                            var n = this.programs[t],
                                r = this.fn(t);
                            return e || o || s || i ? (n = d(this, t, r, e, i, s, o)) : n || (n = this.programs[t] = d(this, t, r)), n;
                        },
                        data: function (t, e) {
                            for (; t && e--; ) t = t._parent;
                            return t;
                        },
                        merge: function (t, e) {
                            var i = t || e;
                            return t && e && t !== e && (i = u.extend({}, e, t)), i;
                        },
                        noop: a.VM.noop,
                        compilerInfo: l.compiler,
                    };
                    return (
                        (c.isTop = !0),
                        (c._setup = function (t) {
                            t.partial
                                ? ((p.helpers = t.helpers), (p.partials = t.partials), (p.decorators = t.decorators))
                                : ((p.helpers = p.merge(t.helpers, a.helpers)), l.usePartial && (p.partials = p.merge(t.partials, a.partials)), (l.usePartial || l.useDecorators) && (p.decorators = p.merge(t.decorators, a.decorators)));
                        }),
                        (c._child = function (t, e, i, s) {
                            if (l.useBlockParams && !i) throw new f.default("must pass block params");
                            if (l.useDepths && !s) throw new f.default("must pass parent depths");
                            return d(p, t, l[t], e, 0, i, s);
                        }),
                        c
                    );
                }),
                (e.wrapProgram = d),
                (e.resolvePartial = function (t, e, i) {
                    return t ? t.call || i.name || ((i.name = t), (t = i.partials[t])) : (t = "@partial-block" === i.name ? i.data["partial-block"] : i.partials[i.name]), t;
                }),
                (e.invokePartial = function (t, e, i) {
                    (i.partial = !0), i.ids && (i.data.contextPath = i.ids[0] || i.data.contextPath);
                    var s = void 0;
                    if ((i.fn && i.fn !== o && ((i.data = m.createFrame(i.data)), (s = i.data["partial-block"] = i.fn).partials && (i.partials = u.extend({}, i.partials, s.partials))), void 0 === t && s && (t = s), void 0 === t))
                        throw new f.default("The partial " + i.name + " could not be found");
                    return t instanceof Function ? t(e, i) : void 0;
                }),
                (e.noop = o);
            var u = s(i(5)),
                f = n(i(6)),
                m = i(4);
        },
        function (t, e) {
            (function (s) {
                "use strict";
                (e.__esModule = !0),
                    (e.default = function (t) {
                        var e = void 0 !== s ? s : window,
                            i = e.Handlebars;
                        t.noConflict = function () {
                            return e.Handlebars === t && (e.Handlebars = i), t;
                        };
                    }),
                    (t.exports = e.default);
            }.call(
                e,
                (function () {
                    return this;
                })()
            ));
        },
        function (t, e) {
            "use strict";
            e.__esModule = !0;
            var i = {
                helpers: {
                    helperExpression: function (t) {
                        return "SubExpression" === t.type || (("MustacheStatement" === t.type || "BlockStatement" === t.type) && !!((t.params && t.params.length) || t.hash));
                    },
                    scopedId: function (t) {
                        return /^\.|this\b/.test(t.original);
                    },
                    simpleId: function (t) {
                        return 1 === t.parts.length && !i.helpers.scopedId(t) && !t.depth;
                    },
                },
            };
            (e.default = i), (t.exports = e.default);
        },
        function (t, e, i) {
            "use strict";
            var s = i(1).default,
                o = i(3).default;
            (e.__esModule = !0),
                (e.parse = function (t, e) {
                    return "Program" === t.type
                        ? t
                        : (((n.default.yy = c).locInfo = function (t) {
                              return new c.SourceLocation(e && e.srcName, t);
                          }),
                          new r.default(e).accept(n.default.parse(t)));
                });
            var n = s(i(23)),
                r = s(i(24)),
                a = o(i(26)),
                l = i(5);
            e.parser = n.default;
            var c = {};
            l.extend(c, a);
        },
        function (t, e) {
            "use strict";
            var i = (function () {
                function t() {
                    this.yy = {};
                }
                var e = {
                        trace: function () {},
                        yy: {},
                        symbols_: {
                            error: 2,
                            root: 3,
                            program: 4,
                            EOF: 5,
                            program_repetition0: 6,
                            statement: 7,
                            mustache: 8,
                            block: 9,
                            rawBlock: 10,
                            partial: 11,
                            partialBlock: 12,
                            content: 13,
                            COMMENT: 14,
                            CONTENT: 15,
                            openRawBlock: 16,
                            rawBlock_repetition_plus0: 17,
                            END_RAW_BLOCK: 18,
                            OPEN_RAW_BLOCK: 19,
                            helperName: 20,
                            openRawBlock_repetition0: 21,
                            openRawBlock_option0: 22,
                            CLOSE_RAW_BLOCK: 23,
                            openBlock: 24,
                            block_option0: 25,
                            closeBlock: 26,
                            openInverse: 27,
                            block_option1: 28,
                            OPEN_BLOCK: 29,
                            openBlock_repetition0: 30,
                            openBlock_option0: 31,
                            openBlock_option1: 32,
                            CLOSE: 33,
                            OPEN_INVERSE: 34,
                            openInverse_repetition0: 35,
                            openInverse_option0: 36,
                            openInverse_option1: 37,
                            openInverseChain: 38,
                            OPEN_INVERSE_CHAIN: 39,
                            openInverseChain_repetition0: 40,
                            openInverseChain_option0: 41,
                            openInverseChain_option1: 42,
                            inverseAndProgram: 43,
                            INVERSE: 44,
                            inverseChain: 45,
                            inverseChain_option0: 46,
                            OPEN_ENDBLOCK: 47,
                            OPEN: 48,
                            mustache_repetition0: 49,
                            mustache_option0: 50,
                            OPEN_UNESCAPED: 51,
                            mustache_repetition1: 52,
                            mustache_option1: 53,
                            CLOSE_UNESCAPED: 54,
                            OPEN_PARTIAL: 55,
                            partialName: 56,
                            partial_repetition0: 57,
                            partial_option0: 58,
                            openPartialBlock: 59,
                            OPEN_PARTIAL_BLOCK: 60,
                            openPartialBlock_repetition0: 61,
                            openPartialBlock_option0: 62,
                            param: 63,
                            sexpr: 64,
                            OPEN_SEXPR: 65,
                            sexpr_repetition0: 66,
                            sexpr_option0: 67,
                            CLOSE_SEXPR: 68,
                            hash: 69,
                            hash_repetition_plus0: 70,
                            hashSegment: 71,
                            ID: 72,
                            EQUALS: 73,
                            blockParams: 74,
                            OPEN_BLOCK_PARAMS: 75,
                            blockParams_repetition_plus0: 76,
                            CLOSE_BLOCK_PARAMS: 77,
                            path: 78,
                            dataName: 79,
                            STRING: 80,
                            NUMBER: 81,
                            BOOLEAN: 82,
                            UNDEFINED: 83,
                            NULL: 84,
                            DATA: 85,
                            pathSegments: 86,
                            SEP: 87,
                            $accept: 0,
                            $end: 1,
                        },
                        terminals_: {
                            2: "error",
                            5: "EOF",
                            14: "COMMENT",
                            15: "CONTENT",
                            18: "END_RAW_BLOCK",
                            19: "OPEN_RAW_BLOCK",
                            23: "CLOSE_RAW_BLOCK",
                            29: "OPEN_BLOCK",
                            33: "CLOSE",
                            34: "OPEN_INVERSE",
                            39: "OPEN_INVERSE_CHAIN",
                            44: "INVERSE",
                            47: "OPEN_ENDBLOCK",
                            48: "OPEN",
                            51: "OPEN_UNESCAPED",
                            54: "CLOSE_UNESCAPED",
                            55: "OPEN_PARTIAL",
                            60: "OPEN_PARTIAL_BLOCK",
                            65: "OPEN_SEXPR",
                            68: "CLOSE_SEXPR",
                            72: "ID",
                            73: "EQUALS",
                            75: "OPEN_BLOCK_PARAMS",
                            77: "CLOSE_BLOCK_PARAMS",
                            80: "STRING",
                            81: "NUMBER",
                            82: "BOOLEAN",
                            83: "UNDEFINED",
                            84: "NULL",
                            85: "DATA",
                            87: "SEP",
                        },
                        productions_: [
                            0,
                            [3, 2],
                            [4, 1],
                            [7, 1],
                            [7, 1],
                            [7, 1],
                            [7, 1],
                            [7, 1],
                            [7, 1],
                            [7, 1],
                            [13, 1],
                            [10, 3],
                            [16, 5],
                            [9, 4],
                            [9, 4],
                            [24, 6],
                            [27, 6],
                            [38, 6],
                            [43, 2],
                            [45, 3],
                            [45, 1],
                            [26, 3],
                            [8, 5],
                            [8, 5],
                            [11, 5],
                            [12, 3],
                            [59, 5],
                            [63, 1],
                            [63, 1],
                            [64, 5],
                            [69, 1],
                            [71, 3],
                            [74, 3],
                            [20, 1],
                            [20, 1],
                            [20, 1],
                            [20, 1],
                            [20, 1],
                            [20, 1],
                            [20, 1],
                            [56, 1],
                            [56, 1],
                            [79, 2],
                            [78, 1],
                            [86, 3],
                            [86, 1],
                            [6, 0],
                            [6, 2],
                            [17, 1],
                            [17, 2],
                            [21, 0],
                            [21, 2],
                            [22, 0],
                            [22, 1],
                            [25, 0],
                            [25, 1],
                            [28, 0],
                            [28, 1],
                            [30, 0],
                            [30, 2],
                            [31, 0],
                            [31, 1],
                            [32, 0],
                            [32, 1],
                            [35, 0],
                            [35, 2],
                            [36, 0],
                            [36, 1],
                            [37, 0],
                            [37, 1],
                            [40, 0],
                            [40, 2],
                            [41, 0],
                            [41, 1],
                            [42, 0],
                            [42, 1],
                            [46, 0],
                            [46, 1],
                            [49, 0],
                            [49, 2],
                            [50, 0],
                            [50, 1],
                            [52, 0],
                            [52, 2],
                            [53, 0],
                            [53, 1],
                            [57, 0],
                            [57, 2],
                            [58, 0],
                            [58, 1],
                            [61, 0],
                            [61, 2],
                            [62, 0],
                            [62, 1],
                            [66, 0],
                            [66, 2],
                            [67, 0],
                            [67, 1],
                            [70, 1],
                            [70, 2],
                            [76, 1],
                            [76, 2],
                        ],
                        performAction: function (t, e, i, s, o, n, r) {
                            var a = n.length - 1;
                            switch (o) {
                                case 1:
                                    return n[a - 1];
                                case 2:
                                    this.$ = s.prepareProgram(n[a]);
                                    break;
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                case 7:
                                case 8:
                                    this.$ = n[a];
                                    break;
                                case 9:
                                    this.$ = { type: "CommentStatement", value: s.stripComment(n[a]), strip: s.stripFlags(n[a], n[a]), loc: s.locInfo(this._$) };
                                    break;
                                case 10:
                                    this.$ = { type: "ContentStatement", original: n[a], value: n[a], loc: s.locInfo(this._$) };
                                    break;
                                case 11:
                                    this.$ = s.prepareRawBlock(n[a - 2], n[a - 1], n[a], this._$);
                                    break;
                                case 12:
                                    this.$ = { path: n[a - 3], params: n[a - 2], hash: n[a - 1] };
                                    break;
                                case 13:
                                    this.$ = s.prepareBlock(n[a - 3], n[a - 2], n[a - 1], n[a], !1, this._$);
                                    break;
                                case 14:
                                    this.$ = s.prepareBlock(n[a - 3], n[a - 2], n[a - 1], n[a], !0, this._$);
                                    break;
                                case 15:
                                    this.$ = { open: n[a - 5], path: n[a - 4], params: n[a - 3], hash: n[a - 2], blockParams: n[a - 1], strip: s.stripFlags(n[a - 5], n[a]) };
                                    break;
                                case 16:
                                case 17:
                                    this.$ = { path: n[a - 4], params: n[a - 3], hash: n[a - 2], blockParams: n[a - 1], strip: s.stripFlags(n[a - 5], n[a]) };
                                    break;
                                case 18:
                                    this.$ = { strip: s.stripFlags(n[a - 1], n[a - 1]), program: n[a] };
                                    break;
                                case 19:
                                    var l = s.prepareBlock(n[a - 2], n[a - 1], n[a], n[a], !1, this._$),
                                        c = s.prepareProgram([l], n[a - 1].loc);
                                    (c.chained = !0), (this.$ = { strip: n[a - 2].strip, program: c, chain: !0 });
                                    break;
                                case 20:
                                    this.$ = n[a];
                                    break;
                                case 21:
                                    this.$ = { path: n[a - 1], strip: s.stripFlags(n[a - 2], n[a]) };
                                    break;
                                case 22:
                                case 23:
                                    this.$ = s.prepareMustache(n[a - 3], n[a - 2], n[a - 1], n[a - 4], s.stripFlags(n[a - 4], n[a]), this._$);
                                    break;
                                case 24:
                                    this.$ = { type: "PartialStatement", name: n[a - 3], params: n[a - 2], hash: n[a - 1], indent: "", strip: s.stripFlags(n[a - 4], n[a]), loc: s.locInfo(this._$) };
                                    break;
                                case 25:
                                    this.$ = s.preparePartialBlock(n[a - 2], n[a - 1], n[a], this._$);
                                    break;
                                case 26:
                                    this.$ = { path: n[a - 3], params: n[a - 2], hash: n[a - 1], strip: s.stripFlags(n[a - 4], n[a]) };
                                    break;
                                case 27:
                                case 28:
                                    this.$ = n[a];
                                    break;
                                case 29:
                                    this.$ = { type: "SubExpression", path: n[a - 3], params: n[a - 2], hash: n[a - 1], loc: s.locInfo(this._$) };
                                    break;
                                case 30:
                                    this.$ = { type: "Hash", pairs: n[a], loc: s.locInfo(this._$) };
                                    break;
                                case 31:
                                    this.$ = { type: "HashPair", key: s.id(n[a - 2]), value: n[a], loc: s.locInfo(this._$) };
                                    break;
                                case 32:
                                    this.$ = s.id(n[a - 1]);
                                    break;
                                case 33:
                                case 34:
                                    this.$ = n[a];
                                    break;
                                case 35:
                                    this.$ = { type: "StringLiteral", value: n[a], original: n[a], loc: s.locInfo(this._$) };
                                    break;
                                case 36:
                                    this.$ = { type: "NumberLiteral", value: Number(n[a]), original: Number(n[a]), loc: s.locInfo(this._$) };
                                    break;
                                case 37:
                                    this.$ = { type: "BooleanLiteral", value: "true" === n[a], original: "true" === n[a], loc: s.locInfo(this._$) };
                                    break;
                                case 38:
                                    this.$ = { type: "UndefinedLiteral", original: void 0, value: void 0, loc: s.locInfo(this._$) };
                                    break;
                                case 39:
                                    this.$ = { type: "NullLiteral", original: null, value: null, loc: s.locInfo(this._$) };
                                    break;
                                case 40:
                                case 41:
                                    this.$ = n[a];
                                    break;
                                case 42:
                                    this.$ = s.preparePath(!0, n[a], this._$);
                                    break;
                                case 43:
                                    this.$ = s.preparePath(!1, n[a], this._$);
                                    break;
                                case 44:
                                    n[a - 2].push({ part: s.id(n[a]), original: n[a], separator: n[a - 1] }), (this.$ = n[a - 2]);
                                    break;
                                case 45:
                                    this.$ = [{ part: s.id(n[a]), original: n[a] }];
                                    break;
                                case 46:
                                    this.$ = [];
                                    break;
                                case 47:
                                    n[a - 1].push(n[a]);
                                    break;
                                case 48:
                                    this.$ = [n[a]];
                                    break;
                                case 49:
                                    n[a - 1].push(n[a]);
                                    break;
                                case 50:
                                    this.$ = [];
                                    break;
                                case 51:
                                    n[a - 1].push(n[a]);
                                    break;
                                case 58:
                                    this.$ = [];
                                    break;
                                case 59:
                                    n[a - 1].push(n[a]);
                                    break;
                                case 64:
                                    this.$ = [];
                                    break;
                                case 65:
                                    n[a - 1].push(n[a]);
                                    break;
                                case 70:
                                    this.$ = [];
                                    break;
                                case 71:
                                    n[a - 1].push(n[a]);
                                    break;
                                case 78:
                                    this.$ = [];
                                    break;
                                case 79:
                                    n[a - 1].push(n[a]);
                                    break;
                                case 82:
                                    this.$ = [];
                                    break;
                                case 83:
                                    n[a - 1].push(n[a]);
                                    break;
                                case 86:
                                    this.$ = [];
                                    break;
                                case 87:
                                    n[a - 1].push(n[a]);
                                    break;
                                case 90:
                                    this.$ = [];
                                    break;
                                case 91:
                                    n[a - 1].push(n[a]);
                                    break;
                                case 94:
                                    this.$ = [];
                                    break;
                                case 95:
                                    n[a - 1].push(n[a]);
                                    break;
                                case 98:
                                    this.$ = [n[a]];
                                    break;
                                case 99:
                                    n[a - 1].push(n[a]);
                                    break;
                                case 100:
                                    this.$ = [n[a]];
                                    break;
                                case 101:
                                    n[a - 1].push(n[a]);
                            }
                        },
                        table: [
                            { 3: 1, 4: 2, 5: [2, 46], 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] },
                            { 1: [3] },
                            { 5: [1, 4] },
                            {
                                5: [2, 2],
                                7: 5,
                                8: 6,
                                9: 7,
                                10: 8,
                                11: 9,
                                12: 10,
                                13: 11,
                                14: [1, 12],
                                15: [1, 20],
                                16: 17,
                                19: [1, 23],
                                24: 15,
                                27: 16,
                                29: [1, 21],
                                34: [1, 22],
                                39: [2, 2],
                                44: [2, 2],
                                47: [2, 2],
                                48: [1, 13],
                                51: [1, 14],
                                55: [1, 18],
                                59: 19,
                                60: [1, 24],
                            },
                            { 1: [2, 1] },
                            { 5: [2, 47], 14: [2, 47], 15: [2, 47], 19: [2, 47], 29: [2, 47], 34: [2, 47], 39: [2, 47], 44: [2, 47], 47: [2, 47], 48: [2, 47], 51: [2, 47], 55: [2, 47], 60: [2, 47] },
                            { 5: [2, 3], 14: [2, 3], 15: [2, 3], 19: [2, 3], 29: [2, 3], 34: [2, 3], 39: [2, 3], 44: [2, 3], 47: [2, 3], 48: [2, 3], 51: [2, 3], 55: [2, 3], 60: [2, 3] },
                            { 5: [2, 4], 14: [2, 4], 15: [2, 4], 19: [2, 4], 29: [2, 4], 34: [2, 4], 39: [2, 4], 44: [2, 4], 47: [2, 4], 48: [2, 4], 51: [2, 4], 55: [2, 4], 60: [2, 4] },
                            { 5: [2, 5], 14: [2, 5], 15: [2, 5], 19: [2, 5], 29: [2, 5], 34: [2, 5], 39: [2, 5], 44: [2, 5], 47: [2, 5], 48: [2, 5], 51: [2, 5], 55: [2, 5], 60: [2, 5] },
                            { 5: [2, 6], 14: [2, 6], 15: [2, 6], 19: [2, 6], 29: [2, 6], 34: [2, 6], 39: [2, 6], 44: [2, 6], 47: [2, 6], 48: [2, 6], 51: [2, 6], 55: [2, 6], 60: [2, 6] },
                            { 5: [2, 7], 14: [2, 7], 15: [2, 7], 19: [2, 7], 29: [2, 7], 34: [2, 7], 39: [2, 7], 44: [2, 7], 47: [2, 7], 48: [2, 7], 51: [2, 7], 55: [2, 7], 60: [2, 7] },
                            { 5: [2, 8], 14: [2, 8], 15: [2, 8], 19: [2, 8], 29: [2, 8], 34: [2, 8], 39: [2, 8], 44: [2, 8], 47: [2, 8], 48: [2, 8], 51: [2, 8], 55: [2, 8], 60: [2, 8] },
                            { 5: [2, 9], 14: [2, 9], 15: [2, 9], 19: [2, 9], 29: [2, 9], 34: [2, 9], 39: [2, 9], 44: [2, 9], 47: [2, 9], 48: [2, 9], 51: [2, 9], 55: [2, 9], 60: [2, 9] },
                            { 20: 25, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 },
                            { 20: 36, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 },
                            { 4: 37, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 39: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] },
                            { 4: 38, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] },
                            { 13: 40, 15: [1, 20], 17: 39 },
                            { 20: 42, 56: 41, 64: 43, 65: [1, 44], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 },
                            { 4: 45, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] },
                            { 5: [2, 10], 14: [2, 10], 15: [2, 10], 18: [2, 10], 19: [2, 10], 29: [2, 10], 34: [2, 10], 39: [2, 10], 44: [2, 10], 47: [2, 10], 48: [2, 10], 51: [2, 10], 55: [2, 10], 60: [2, 10] },
                            { 20: 46, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 },
                            { 20: 47, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 },
                            { 20: 48, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 },
                            { 20: 42, 56: 49, 64: 43, 65: [1, 44], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 },
                            { 33: [2, 78], 49: 50, 65: [2, 78], 72: [2, 78], 80: [2, 78], 81: [2, 78], 82: [2, 78], 83: [2, 78], 84: [2, 78], 85: [2, 78] },
                            { 23: [2, 33], 33: [2, 33], 54: [2, 33], 65: [2, 33], 68: [2, 33], 72: [2, 33], 75: [2, 33], 80: [2, 33], 81: [2, 33], 82: [2, 33], 83: [2, 33], 84: [2, 33], 85: [2, 33] },
                            { 23: [2, 34], 33: [2, 34], 54: [2, 34], 65: [2, 34], 68: [2, 34], 72: [2, 34], 75: [2, 34], 80: [2, 34], 81: [2, 34], 82: [2, 34], 83: [2, 34], 84: [2, 34], 85: [2, 34] },
                            { 23: [2, 35], 33: [2, 35], 54: [2, 35], 65: [2, 35], 68: [2, 35], 72: [2, 35], 75: [2, 35], 80: [2, 35], 81: [2, 35], 82: [2, 35], 83: [2, 35], 84: [2, 35], 85: [2, 35] },
                            { 23: [2, 36], 33: [2, 36], 54: [2, 36], 65: [2, 36], 68: [2, 36], 72: [2, 36], 75: [2, 36], 80: [2, 36], 81: [2, 36], 82: [2, 36], 83: [2, 36], 84: [2, 36], 85: [2, 36] },
                            { 23: [2, 37], 33: [2, 37], 54: [2, 37], 65: [2, 37], 68: [2, 37], 72: [2, 37], 75: [2, 37], 80: [2, 37], 81: [2, 37], 82: [2, 37], 83: [2, 37], 84: [2, 37], 85: [2, 37] },
                            { 23: [2, 38], 33: [2, 38], 54: [2, 38], 65: [2, 38], 68: [2, 38], 72: [2, 38], 75: [2, 38], 80: [2, 38], 81: [2, 38], 82: [2, 38], 83: [2, 38], 84: [2, 38], 85: [2, 38] },
                            { 23: [2, 39], 33: [2, 39], 54: [2, 39], 65: [2, 39], 68: [2, 39], 72: [2, 39], 75: [2, 39], 80: [2, 39], 81: [2, 39], 82: [2, 39], 83: [2, 39], 84: [2, 39], 85: [2, 39] },
                            { 23: [2, 43], 33: [2, 43], 54: [2, 43], 65: [2, 43], 68: [2, 43], 72: [2, 43], 75: [2, 43], 80: [2, 43], 81: [2, 43], 82: [2, 43], 83: [2, 43], 84: [2, 43], 85: [2, 43], 87: [1, 51] },
                            { 72: [1, 35], 86: 52 },
                            { 23: [2, 45], 33: [2, 45], 54: [2, 45], 65: [2, 45], 68: [2, 45], 72: [2, 45], 75: [2, 45], 80: [2, 45], 81: [2, 45], 82: [2, 45], 83: [2, 45], 84: [2, 45], 85: [2, 45], 87: [2, 45] },
                            { 52: 53, 54: [2, 82], 65: [2, 82], 72: [2, 82], 80: [2, 82], 81: [2, 82], 82: [2, 82], 83: [2, 82], 84: [2, 82], 85: [2, 82] },
                            { 25: 54, 38: 56, 39: [1, 58], 43: 57, 44: [1, 59], 45: 55, 47: [2, 54] },
                            { 28: 60, 43: 61, 44: [1, 59], 47: [2, 56] },
                            { 13: 63, 15: [1, 20], 18: [1, 62] },
                            { 15: [2, 48], 18: [2, 48] },
                            { 33: [2, 86], 57: 64, 65: [2, 86], 72: [2, 86], 80: [2, 86], 81: [2, 86], 82: [2, 86], 83: [2, 86], 84: [2, 86], 85: [2, 86] },
                            { 33: [2, 40], 65: [2, 40], 72: [2, 40], 80: [2, 40], 81: [2, 40], 82: [2, 40], 83: [2, 40], 84: [2, 40], 85: [2, 40] },
                            { 33: [2, 41], 65: [2, 41], 72: [2, 41], 80: [2, 41], 81: [2, 41], 82: [2, 41], 83: [2, 41], 84: [2, 41], 85: [2, 41] },
                            { 20: 65, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 },
                            { 26: 66, 47: [1, 67] },
                            { 30: 68, 33: [2, 58], 65: [2, 58], 72: [2, 58], 75: [2, 58], 80: [2, 58], 81: [2, 58], 82: [2, 58], 83: [2, 58], 84: [2, 58], 85: [2, 58] },
                            { 33: [2, 64], 35: 69, 65: [2, 64], 72: [2, 64], 75: [2, 64], 80: [2, 64], 81: [2, 64], 82: [2, 64], 83: [2, 64], 84: [2, 64], 85: [2, 64] },
                            { 21: 70, 23: [2, 50], 65: [2, 50], 72: [2, 50], 80: [2, 50], 81: [2, 50], 82: [2, 50], 83: [2, 50], 84: [2, 50], 85: [2, 50] },
                            { 33: [2, 90], 61: 71, 65: [2, 90], 72: [2, 90], 80: [2, 90], 81: [2, 90], 82: [2, 90], 83: [2, 90], 84: [2, 90], 85: [2, 90] },
                            { 20: 75, 33: [2, 80], 50: 72, 63: 73, 64: 76, 65: [1, 44], 69: 74, 70: 77, 71: 78, 72: [1, 79], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 },
                            { 72: [1, 80] },
                            { 23: [2, 42], 33: [2, 42], 54: [2, 42], 65: [2, 42], 68: [2, 42], 72: [2, 42], 75: [2, 42], 80: [2, 42], 81: [2, 42], 82: [2, 42], 83: [2, 42], 84: [2, 42], 85: [2, 42], 87: [1, 51] },
                            { 20: 75, 53: 81, 54: [2, 84], 63: 82, 64: 76, 65: [1, 44], 69: 83, 70: 77, 71: 78, 72: [1, 79], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 },
                            { 26: 84, 47: [1, 67] },
                            { 47: [2, 55] },
                            { 4: 85, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 39: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] },
                            { 47: [2, 20] },
                            { 20: 86, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 },
                            { 4: 87, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] },
                            { 26: 88, 47: [1, 67] },
                            { 47: [2, 57] },
                            { 5: [2, 11], 14: [2, 11], 15: [2, 11], 19: [2, 11], 29: [2, 11], 34: [2, 11], 39: [2, 11], 44: [2, 11], 47: [2, 11], 48: [2, 11], 51: [2, 11], 55: [2, 11], 60: [2, 11] },
                            { 15: [2, 49], 18: [2, 49] },
                            { 20: 75, 33: [2, 88], 58: 89, 63: 90, 64: 76, 65: [1, 44], 69: 91, 70: 77, 71: 78, 72: [1, 79], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 },
                            { 65: [2, 94], 66: 92, 68: [2, 94], 72: [2, 94], 80: [2, 94], 81: [2, 94], 82: [2, 94], 83: [2, 94], 84: [2, 94], 85: [2, 94] },
                            { 5: [2, 25], 14: [2, 25], 15: [2, 25], 19: [2, 25], 29: [2, 25], 34: [2, 25], 39: [2, 25], 44: [2, 25], 47: [2, 25], 48: [2, 25], 51: [2, 25], 55: [2, 25], 60: [2, 25] },
                            { 20: 93, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 },
                            {
                                20: 75,
                                31: 94,
                                33: [2, 60],
                                63: 95,
                                64: 76,
                                65: [1, 44],
                                69: 96,
                                70: 77,
                                71: 78,
                                72: [1, 79],
                                75: [2, 60],
                                78: 26,
                                79: 27,
                                80: [1, 28],
                                81: [1, 29],
                                82: [1, 30],
                                83: [1, 31],
                                84: [1, 32],
                                85: [1, 34],
                                86: 33,
                            },
                            {
                                20: 75,
                                33: [2, 66],
                                36: 97,
                                63: 98,
                                64: 76,
                                65: [1, 44],
                                69: 99,
                                70: 77,
                                71: 78,
                                72: [1, 79],
                                75: [2, 66],
                                78: 26,
                                79: 27,
                                80: [1, 28],
                                81: [1, 29],
                                82: [1, 30],
                                83: [1, 31],
                                84: [1, 32],
                                85: [1, 34],
                                86: 33,
                            },
                            { 20: 75, 22: 100, 23: [2, 52], 63: 101, 64: 76, 65: [1, 44], 69: 102, 70: 77, 71: 78, 72: [1, 79], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 },
                            { 20: 75, 33: [2, 92], 62: 103, 63: 104, 64: 76, 65: [1, 44], 69: 105, 70: 77, 71: 78, 72: [1, 79], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 },
                            { 33: [1, 106] },
                            { 33: [2, 79], 65: [2, 79], 72: [2, 79], 80: [2, 79], 81: [2, 79], 82: [2, 79], 83: [2, 79], 84: [2, 79], 85: [2, 79] },
                            { 33: [2, 81] },
                            { 23: [2, 27], 33: [2, 27], 54: [2, 27], 65: [2, 27], 68: [2, 27], 72: [2, 27], 75: [2, 27], 80: [2, 27], 81: [2, 27], 82: [2, 27], 83: [2, 27], 84: [2, 27], 85: [2, 27] },
                            { 23: [2, 28], 33: [2, 28], 54: [2, 28], 65: [2, 28], 68: [2, 28], 72: [2, 28], 75: [2, 28], 80: [2, 28], 81: [2, 28], 82: [2, 28], 83: [2, 28], 84: [2, 28], 85: [2, 28] },
                            { 23: [2, 30], 33: [2, 30], 54: [2, 30], 68: [2, 30], 71: 107, 72: [1, 108], 75: [2, 30] },
                            { 23: [2, 98], 33: [2, 98], 54: [2, 98], 68: [2, 98], 72: [2, 98], 75: [2, 98] },
                            { 23: [2, 45], 33: [2, 45], 54: [2, 45], 65: [2, 45], 68: [2, 45], 72: [2, 45], 73: [1, 109], 75: [2, 45], 80: [2, 45], 81: [2, 45], 82: [2, 45], 83: [2, 45], 84: [2, 45], 85: [2, 45], 87: [2, 45] },
                            { 23: [2, 44], 33: [2, 44], 54: [2, 44], 65: [2, 44], 68: [2, 44], 72: [2, 44], 75: [2, 44], 80: [2, 44], 81: [2, 44], 82: [2, 44], 83: [2, 44], 84: [2, 44], 85: [2, 44], 87: [2, 44] },
                            { 54: [1, 110] },
                            { 54: [2, 83], 65: [2, 83], 72: [2, 83], 80: [2, 83], 81: [2, 83], 82: [2, 83], 83: [2, 83], 84: [2, 83], 85: [2, 83] },
                            { 54: [2, 85] },
                            { 5: [2, 13], 14: [2, 13], 15: [2, 13], 19: [2, 13], 29: [2, 13], 34: [2, 13], 39: [2, 13], 44: [2, 13], 47: [2, 13], 48: [2, 13], 51: [2, 13], 55: [2, 13], 60: [2, 13] },
                            { 38: 56, 39: [1, 58], 43: 57, 44: [1, 59], 45: 112, 46: 111, 47: [2, 76] },
                            { 33: [2, 70], 40: 113, 65: [2, 70], 72: [2, 70], 75: [2, 70], 80: [2, 70], 81: [2, 70], 82: [2, 70], 83: [2, 70], 84: [2, 70], 85: [2, 70] },
                            { 47: [2, 18] },
                            { 5: [2, 14], 14: [2, 14], 15: [2, 14], 19: [2, 14], 29: [2, 14], 34: [2, 14], 39: [2, 14], 44: [2, 14], 47: [2, 14], 48: [2, 14], 51: [2, 14], 55: [2, 14], 60: [2, 14] },
                            { 33: [1, 114] },
                            { 33: [2, 87], 65: [2, 87], 72: [2, 87], 80: [2, 87], 81: [2, 87], 82: [2, 87], 83: [2, 87], 84: [2, 87], 85: [2, 87] },
                            { 33: [2, 89] },
                            { 20: 75, 63: 116, 64: 76, 65: [1, 44], 67: 115, 68: [2, 96], 69: 117, 70: 77, 71: 78, 72: [1, 79], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 },
                            { 33: [1, 118] },
                            { 32: 119, 33: [2, 62], 74: 120, 75: [1, 121] },
                            { 33: [2, 59], 65: [2, 59], 72: [2, 59], 75: [2, 59], 80: [2, 59], 81: [2, 59], 82: [2, 59], 83: [2, 59], 84: [2, 59], 85: [2, 59] },
                            { 33: [2, 61], 75: [2, 61] },
                            { 33: [2, 68], 37: 122, 74: 123, 75: [1, 121] },
                            { 33: [2, 65], 65: [2, 65], 72: [2, 65], 75: [2, 65], 80: [2, 65], 81: [2, 65], 82: [2, 65], 83: [2, 65], 84: [2, 65], 85: [2, 65] },
                            { 33: [2, 67], 75: [2, 67] },
                            { 23: [1, 124] },
                            { 23: [2, 51], 65: [2, 51], 72: [2, 51], 80: [2, 51], 81: [2, 51], 82: [2, 51], 83: [2, 51], 84: [2, 51], 85: [2, 51] },
                            { 23: [2, 53] },
                            { 33: [1, 125] },
                            { 33: [2, 91], 65: [2, 91], 72: [2, 91], 80: [2, 91], 81: [2, 91], 82: [2, 91], 83: [2, 91], 84: [2, 91], 85: [2, 91] },
                            { 33: [2, 93] },
                            { 5: [2, 22], 14: [2, 22], 15: [2, 22], 19: [2, 22], 29: [2, 22], 34: [2, 22], 39: [2, 22], 44: [2, 22], 47: [2, 22], 48: [2, 22], 51: [2, 22], 55: [2, 22], 60: [2, 22] },
                            { 23: [2, 99], 33: [2, 99], 54: [2, 99], 68: [2, 99], 72: [2, 99], 75: [2, 99] },
                            { 73: [1, 109] },
                            { 20: 75, 63: 126, 64: 76, 65: [1, 44], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 },
                            { 5: [2, 23], 14: [2, 23], 15: [2, 23], 19: [2, 23], 29: [2, 23], 34: [2, 23], 39: [2, 23], 44: [2, 23], 47: [2, 23], 48: [2, 23], 51: [2, 23], 55: [2, 23], 60: [2, 23] },
                            { 47: [2, 19] },
                            { 47: [2, 77] },
                            {
                                20: 75,
                                33: [2, 72],
                                41: 127,
                                63: 128,
                                64: 76,
                                65: [1, 44],
                                69: 129,
                                70: 77,
                                71: 78,
                                72: [1, 79],
                                75: [2, 72],
                                78: 26,
                                79: 27,
                                80: [1, 28],
                                81: [1, 29],
                                82: [1, 30],
                                83: [1, 31],
                                84: [1, 32],
                                85: [1, 34],
                                86: 33,
                            },
                            { 5: [2, 24], 14: [2, 24], 15: [2, 24], 19: [2, 24], 29: [2, 24], 34: [2, 24], 39: [2, 24], 44: [2, 24], 47: [2, 24], 48: [2, 24], 51: [2, 24], 55: [2, 24], 60: [2, 24] },
                            { 68: [1, 130] },
                            { 65: [2, 95], 68: [2, 95], 72: [2, 95], 80: [2, 95], 81: [2, 95], 82: [2, 95], 83: [2, 95], 84: [2, 95], 85: [2, 95] },
                            { 68: [2, 97] },
                            { 5: [2, 21], 14: [2, 21], 15: [2, 21], 19: [2, 21], 29: [2, 21], 34: [2, 21], 39: [2, 21], 44: [2, 21], 47: [2, 21], 48: [2, 21], 51: [2, 21], 55: [2, 21], 60: [2, 21] },
                            { 33: [1, 131] },
                            { 33: [2, 63] },
                            { 72: [1, 133], 76: 132 },
                            { 33: [1, 134] },
                            { 33: [2, 69] },
                            { 15: [2, 12] },
                            { 14: [2, 26], 15: [2, 26], 19: [2, 26], 29: [2, 26], 34: [2, 26], 47: [2, 26], 48: [2, 26], 51: [2, 26], 55: [2, 26], 60: [2, 26] },
                            { 23: [2, 31], 33: [2, 31], 54: [2, 31], 68: [2, 31], 72: [2, 31], 75: [2, 31] },
                            { 33: [2, 74], 42: 135, 74: 136, 75: [1, 121] },
                            { 33: [2, 71], 65: [2, 71], 72: [2, 71], 75: [2, 71], 80: [2, 71], 81: [2, 71], 82: [2, 71], 83: [2, 71], 84: [2, 71], 85: [2, 71] },
                            { 33: [2, 73], 75: [2, 73] },
                            { 23: [2, 29], 33: [2, 29], 54: [2, 29], 65: [2, 29], 68: [2, 29], 72: [2, 29], 75: [2, 29], 80: [2, 29], 81: [2, 29], 82: [2, 29], 83: [2, 29], 84: [2, 29], 85: [2, 29] },
                            { 14: [2, 15], 15: [2, 15], 19: [2, 15], 29: [2, 15], 34: [2, 15], 39: [2, 15], 44: [2, 15], 47: [2, 15], 48: [2, 15], 51: [2, 15], 55: [2, 15], 60: [2, 15] },
                            { 72: [1, 138], 77: [1, 137] },
                            { 72: [2, 100], 77: [2, 100] },
                            { 14: [2, 16], 15: [2, 16], 19: [2, 16], 29: [2, 16], 34: [2, 16], 44: [2, 16], 47: [2, 16], 48: [2, 16], 51: [2, 16], 55: [2, 16], 60: [2, 16] },
                            { 33: [1, 139] },
                            { 33: [2, 75] },
                            { 33: [2, 32] },
                            { 72: [2, 101], 77: [2, 101] },
                            { 14: [2, 17], 15: [2, 17], 19: [2, 17], 29: [2, 17], 34: [2, 17], 39: [2, 17], 44: [2, 17], 47: [2, 17], 48: [2, 17], 51: [2, 17], 55: [2, 17], 60: [2, 17] },
                        ],
                        defaultActions: {
                            4: [2, 1],
                            55: [2, 55],
                            57: [2, 20],
                            61: [2, 57],
                            74: [2, 81],
                            83: [2, 85],
                            87: [2, 18],
                            91: [2, 89],
                            102: [2, 53],
                            105: [2, 93],
                            111: [2, 19],
                            112: [2, 77],
                            117: [2, 97],
                            120: [2, 63],
                            123: [2, 69],
                            124: [2, 12],
                            136: [2, 75],
                            137: [2, 32],
                        },
                        parseError: function (t, e) {
                            throw new Error(t);
                        },
                        parse: function (t) {
                            var e = [0],
                                i = [null],
                                s = [],
                                o = this.table,
                                n = "",
                                r = 0,
                                a = 0,
                                l = 0;
                            this.lexer.setInput(t), (this.lexer.yy = this.yy), (this.yy.lexer = this.lexer), void 0 === (this.yy.parser = this).lexer.yylloc && (this.lexer.yylloc = {});
                            var c = this.lexer.yylloc;
                            s.push(c);
                            var p,
                                d = this.lexer.options && this.lexer.options.ranges;
                            "function" == typeof this.yy.parseError && (this.parseError = this.yy.parseError);
                            for (var h, u, f, m, v, g, y, k, S, b = {}; ; ) {
                                if (
                                    ((f = e[e.length - 1]),
                                    this.defaultActions[f] ? (m = this.defaultActions[f]) : (null != h || ((p = void 0), "number" != typeof (p = this.lexer.lex() || 1) && (p = this.symbols_[p] || p), (h = p)), (m = o[f] && o[f][h])),
                                    void 0 === m || !m.length || !m[0])
                                ) {
                                    var w = "";
                                    if (!l) {
                                        for (g in ((S = []), o[f])) this.terminals_[g] && 2 < g && S.push("'" + this.terminals_[g] + "'");
                                        (w = this.lexer.showPosition
                                            ? "Parse error on line " + (r + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + S.join(", ") + ", got '" + (this.terminals_[h] || h) + "'"
                                            : "Parse error on line " + (r + 1) + ": Unexpected " + (1 == h ? "end of input" : "'" + (this.terminals_[h] || h) + "'")),
                                            this.parseError(w, { text: this.lexer.match, token: this.terminals_[h] || h, line: this.lexer.yylineno, loc: c, expected: S });
                                    }
                                }
                                if (m[0] instanceof Array && 1 < m.length) throw new Error("Parse Error: multiple actions possible at state: " + f + ", token: " + h);
                                switch (m[0]) {
                                    case 1:
                                        e.push(h),
                                            i.push(this.lexer.yytext),
                                            s.push(this.lexer.yylloc),
                                            e.push(m[1]),
                                            (h = null),
                                            u ? ((h = u), (u = null)) : ((a = this.lexer.yyleng), (n = this.lexer.yytext), (r = this.lexer.yylineno), (c = this.lexer.yylloc), 0 < l && l--);
                                        break;
                                    case 2:
                                        if (
                                            ((y = this.productions_[m[1]][1]),
                                            (b.$ = i[i.length - y]),
                                            (b._$ = { first_line: s[s.length - (y || 1)].first_line, last_line: s[s.length - 1].last_line, first_column: s[s.length - (y || 1)].first_column, last_column: s[s.length - 1].last_column }),
                                            d && (b._$.range = [s[s.length - (y || 1)].range[0], s[s.length - 1].range[1]]),
                                            void 0 !== (v = this.performAction.call(b, n, a, r, this.yy, m[1], i, s)))
                                        )
                                            return v;
                                        y && ((e = e.slice(0, -1 * y * 2)), (i = i.slice(0, -1 * y)), (s = s.slice(0, -1 * y))),
                                            e.push(this.productions_[m[1]][0]),
                                            i.push(b.$),
                                            s.push(b._$),
                                            (k = o[e[e.length - 2]][e[e.length - 1]]),
                                            e.push(k);
                                        break;
                                    case 3:
                                        return !0;
                                }
                            }
                            return !0;
                        },
                    },
                    i = {
                        EOF: 1,
                        parseError: function (t, e) {
                            if (!this.yy.parser) throw new Error(t);
                            this.yy.parser.parseError(t, e);
                        },
                        setInput: function (t) {
                            return (
                                (this._input = t),
                                (this._more = this._less = this.done = !1),
                                (this.yylineno = this.yyleng = 0),
                                (this.yytext = this.matched = this.match = ""),
                                (this.conditionStack = ["INITIAL"]),
                                (this.yylloc = { first_line: 1, first_column: 0, last_line: 1, last_column: 0 }),
                                this.options.ranges && (this.yylloc.range = [0, 0]),
                                (this.offset = 0),
                                this
                            );
                        },
                        input: function () {
                            var t = this._input[0];
                            return (
                                (this.yytext += t),
                                this.yyleng++,
                                this.offset++,
                                (this.match += t),
                                (this.matched += t),
                                t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++,
                                this.options.ranges && this.yylloc.range[1]++,
                                (this._input = this._input.slice(1)),
                                t
                            );
                        },
                        unput: function (t) {
                            var e = t.length,
                                i = t.split(/(?:\r\n?|\n)/g);
                            (this._input = t + this._input), (this.yytext = this.yytext.substr(0, this.yytext.length - e - 1)), (this.offset -= e);
                            var s = this.match.split(/(?:\r\n?|\n)/g);
                            (this.match = this.match.substr(0, this.match.length - 1)), (this.matched = this.matched.substr(0, this.matched.length - 1)), i.length - 1 && (this.yylineno -= i.length - 1);
                            var o = this.yylloc.range;
                            return (
                                (this.yylloc = {
                                    first_line: this.yylloc.first_line,
                                    last_line: this.yylineno + 1,
                                    first_column: this.yylloc.first_column,
                                    last_column: i ? (i.length === s.length ? this.yylloc.first_column : 0) + s[s.length - i.length].length - i[0].length : this.yylloc.first_column - e,
                                }),
                                this.options.ranges && (this.yylloc.range = [o[0], o[0] + this.yyleng - e]),
                                this
                            );
                        },
                        more: function () {
                            return (this._more = !0), this;
                        },
                        less: function (t) {
                            this.unput(this.match.slice(t));
                        },
                        pastInput: function () {
                            var t = this.matched.substr(0, this.matched.length - this.match.length);
                            return (20 < t.length ? "..." : "") + t.substr(-20).replace(/\n/g, "");
                        },
                        upcomingInput: function () {
                            var t = this.match;
                            return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (20 < t.length ? "..." : "")).replace(/\n/g, "");
                        },
                        showPosition: function () {
                            var t = this.pastInput(),
                                e = new Array(t.length + 1).join("-");
                            return t + this.upcomingInput() + "\n" + e + "^";
                        },
                        next: function () {
                            if (this.done) return this.EOF;
                            var t, e, i, s, o;
                            this._input || (this.done = !0), this._more || ((this.yytext = ""), (this.match = ""));
                            for (var n = this._currentRules(), r = 0; r < n.length && (!(i = this._input.match(this.rules[n[r]])) || (e && !(i[0].length > e[0].length)) || ((e = i), (s = r), this.options.flex)); r++);
                            return e
                                ? ((o = e[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += o.length),
                                  (this.yylloc = {
                                      first_line: this.yylloc.last_line,
                                      last_line: this.yylineno + 1,
                                      first_column: this.yylloc.last_column,
                                      last_column: o ? o[o.length - 1].length - o[o.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + e[0].length,
                                  }),
                                  (this.yytext += e[0]),
                                  (this.match += e[0]),
                                  (this.matches = e),
                                  (this.yyleng = this.yytext.length),
                                  this.options.ranges && (this.yylloc.range = [this.offset, (this.offset += this.yyleng)]),
                                  (this._more = !1),
                                  (this._input = this._input.slice(e[0].length)),
                                  (this.matched += e[0]),
                                  (t = this.performAction.call(this, this.yy, this, n[s], this.conditionStack[this.conditionStack.length - 1])),
                                  this.done && this._input && (this.done = !1),
                                  t || void 0)
                                : "" === this._input
                                ? this.EOF
                                : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), { text: "", token: null, line: this.yylineno });
                        },
                        lex: function () {
                            var t = this.next();
                            return void 0 !== t ? t : this.lex();
                        },
                        begin: function (t) {
                            this.conditionStack.push(t);
                        },
                        popState: function () {
                            return this.conditionStack.pop();
                        },
                        _currentRules: function () {
                            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
                        },
                        topState: function () {
                            return this.conditionStack[this.conditionStack.length - 2];
                        },
                        pushState: function (t) {
                            this.begin(t);
                        },
                        options: {},
                        performAction: function (t, i, e, s) {
                            function o(t, e) {
                                return (i.yytext = i.yytext.substr(t, i.yyleng - e));
                            }
                            switch (e) {
                                case 0:
                                    if (("\\\\" === i.yytext.slice(-2) ? (o(0, 1), this.begin("mu")) : "\\" === i.yytext.slice(-1) ? (o(0, 1), this.begin("emu")) : this.begin("mu"), i.yytext)) return 15;
                                    break;
                                case 1:
                                    return 15;
                                case 2:
                                    return this.popState(), 15;
                                case 3:
                                    return this.begin("raw"), 15;
                                case 4:
                                    return this.popState(), "raw" === this.conditionStack[this.conditionStack.length - 1] ? 15 : ((i.yytext = i.yytext.substr(5, i.yyleng - 9)), "END_RAW_BLOCK");
                                case 5:
                                    return 15;
                                case 6:
                                    return this.popState(), 14;
                                case 7:
                                    return 65;
                                case 8:
                                    return 68;
                                case 9:
                                    return 19;
                                case 10:
                                    return this.popState(), this.begin("raw"), 23;
                                case 11:
                                    return 55;
                                case 12:
                                    return 60;
                                case 13:
                                    return 29;
                                case 14:
                                    return 47;
                                case 15:
                                case 16:
                                    return this.popState(), 44;
                                case 17:
                                    return 34;
                                case 18:
                                    return 39;
                                case 19:
                                    return 51;
                                case 20:
                                    return 48;
                                case 21:
                                    this.unput(i.yytext), this.popState(), this.begin("com");
                                    break;
                                case 22:
                                    return this.popState(), 14;
                                case 23:
                                    return 48;
                                case 24:
                                    return 73;
                                case 25:
                                case 26:
                                    return 72;
                                case 27:
                                    return 87;
                                case 28:
                                    break;
                                case 29:
                                    return this.popState(), 54;
                                case 30:
                                    return this.popState(), 33;
                                case 31:
                                    return (i.yytext = o(1, 2).replace(/\\"/g, '"')), 80;
                                case 32:
                                    return (i.yytext = o(1, 2).replace(/\\'/g, "'")), 80;
                                case 33:
                                    return 85;
                                case 34:
                                case 35:
                                    return 82;
                                case 36:
                                    return 83;
                                case 37:
                                    return 84;
                                case 38:
                                    return 81;
                                case 39:
                                    return 75;
                                case 40:
                                    return 77;
                                case 41:
                                    return 72;
                                case 42:
                                    return (i.yytext = i.yytext.replace(/\\([\\\]])/g, "$1")), 72;
                                case 43:
                                    return "INVALID";
                                case 44:
                                    return 5;
                            }
                        },
                        rules: [
                            /^(?:[^\x00]*?(?=(\{\{)))/,
                            /^(?:[^\x00]+)/,
                            /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,
                            /^(?:\{\{\{\{(?=[^\/]))/,
                            /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/,
                            /^(?:[^\x00]*?(?=(\{\{\{\{)))/,
                            /^(?:[\s\S]*?--(~)?\}\})/,
                            /^(?:\()/,
                            /^(?:\))/,
                            /^(?:\{\{\{\{)/,
                            /^(?:\}\}\}\})/,
                            /^(?:\{\{(~)?>)/,
                            /^(?:\{\{(~)?#>)/,
                            /^(?:\{\{(~)?#\*?)/,
                            /^(?:\{\{(~)?\/)/,
                            /^(?:\{\{(~)?\^\s*(~)?\}\})/,
                            /^(?:\{\{(~)?\s*else\s*(~)?\}\})/,
                            /^(?:\{\{(~)?\^)/,
                            /^(?:\{\{(~)?\s*else\b)/,
                            /^(?:\{\{(~)?\{)/,
                            /^(?:\{\{(~)?&)/,
                            /^(?:\{\{(~)?!--)/,
                            /^(?:\{\{(~)?![\s\S]*?\}\})/,
                            /^(?:\{\{(~)?\*?)/,
                            /^(?:=)/,
                            /^(?:\.\.)/,
                            /^(?:\.(?=([=~}\s\/.)|])))/,
                            /^(?:[\/.])/,
                            /^(?:\s+)/,
                            /^(?:\}(~)?\}\})/,
                            /^(?:(~)?\}\})/,
                            /^(?:"(\\["]|[^"])*")/,
                            /^(?:'(\\[']|[^'])*')/,
                            /^(?:@)/,
                            /^(?:true(?=([~}\s)])))/,
                            /^(?:false(?=([~}\s)])))/,
                            /^(?:undefined(?=([~}\s)])))/,
                            /^(?:null(?=([~}\s)])))/,
                            /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/,
                            /^(?:as\s+\|)/,
                            /^(?:\|)/,
                            /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/,
                            /^(?:\[(\\\]|[^\]])*\])/,
                            /^(?:.)/,
                            /^(?:$)/,
                        ],
                        conditions: {
                            mu: { rules: [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44], inclusive: !1 },
                            emu: { rules: [2], inclusive: !1 },
                            com: { rules: [6], inclusive: !1 },
                            raw: { rules: [3, 4, 5], inclusive: !1 },
                            INITIAL: { rules: [0, 1, 44], inclusive: !0 },
                        },
                    };
                return (e.lexer = i), new ((t.prototype = e).Parser = t)();
            })();
            (e.__esModule = !0), (e.default = i);
        },
        function (t, e, i) {
            "use strict";
            function s() {
                var t = arguments.length <= 0 || void 0 === arguments[0] ? {} : arguments[0];
                this.options = t;
            }
            function u(t, e, i) {
                void 0 === e && (e = t.length);
                var s = t[e - 1],
                    o = t[e - 2];
                return s ? ("ContentStatement" === s.type ? (o || !i ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(s.original) : void 0) : i;
            }
            function f(t, e, i) {
                void 0 === e && (e = -1);
                var s = t[e + 1],
                    o = t[e + 2];
                return s ? ("ContentStatement" === s.type ? (o || !i ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(s.original) : void 0) : i;
            }
            function m(t, e, i) {
                var s = t[null == e ? 0 : e + 1];
                if (s && "ContentStatement" === s.type && (i || !s.rightStripped)) {
                    var o = s.value;
                    (s.value = s.value.replace(i ? /^\s+/ : /^[ \t]*\r?\n?/, "")), (s.rightStripped = s.value !== o);
                }
            }
            function v(t, e, i) {
                var s = t[null == e ? t.length - 1 : e - 1];
                if (s && "ContentStatement" === s.type && (i || !s.leftStripped)) {
                    var o = s.value;
                    return (s.value = s.value.replace(i ? /\s+$/ : /[ \t]+$/, "")), (s.leftStripped = s.value !== o), s.leftStripped;
                }
            }
            var o = i(1).default;
            e.__esModule = !0;
            var n = o(i(25));
            (s.prototype = new n.default()),
                (s.prototype.Program = function (t) {
                    var e = !this.options.ignoreStandalone,
                        i = !this.isRootSeen;
                    this.isRootSeen = !0;
                    for (var s = t.body, o = 0, n = s.length; o < n; o++) {
                        var r = s[o],
                            a = this.accept(r);
                        if (a) {
                            var l = u(s, o, i),
                                c = f(s, o, i),
                                p = a.openStandalone && l,
                                d = a.closeStandalone && c,
                                h = a.inlineStandalone && l && c;
                            a.close && m(s, o, !0),
                                a.open && v(s, o, !0),
                                e && h && (m(s, o), v(s, o) && "PartialStatement" === r.type && (r.indent = /([ \t]+$)/.exec(s[o - 1].original)[1])),
                                e && p && (m((r.program || r.inverse).body), v(s, o)),
                                e && d && (m(s, o), v((r.inverse || r.program).body));
                        }
                    }
                    return t;
                }),
                (s.prototype.BlockStatement = s.prototype.DecoratorBlock = s.prototype.PartialBlockStatement = function (t) {
                    this.accept(t.program), this.accept(t.inverse);
                    var e = t.program || t.inverse,
                        i = t.program && t.inverse,
                        s = i,
                        o = i;
                    if (i && i.chained) for (s = i.body[0].program; o.chained; ) o = o.body[o.body.length - 1].program;
                    var n = { open: t.openStrip.open, close: t.closeStrip.close, openStandalone: f(e.body), closeStandalone: u((s || e).body) };
                    if ((t.openStrip.close && m(e.body, null, !0), i)) {
                        var r = t.inverseStrip;
                        r.open && v(e.body, null, !0), r.close && m(s.body, null, !0), t.closeStrip.open && v(o.body, null, !0), !this.options.ignoreStandalone && u(e.body) && f(s.body) && (v(e.body), m(s.body));
                    } else t.closeStrip.open && v(e.body, null, !0);
                    return n;
                }),
                (s.prototype.Decorator = s.prototype.MustacheStatement = function (t) {
                    return t.strip;
                }),
                (s.prototype.PartialStatement = s.prototype.CommentStatement = function (t) {
                    var e = t.strip || {};
                    return { inlineStandalone: !0, open: e.open, close: e.close };
                }),
                (e.default = s),
                (t.exports = e.default);
        },
        function (t, e, i) {
            "use strict";
            function s() {
                this.parents = [];
            }
            function o(t) {
                this.acceptRequired(t, "path"), this.acceptArray(t.params), this.acceptKey(t, "hash");
            }
            function n(t) {
                o.call(this, t), this.acceptKey(t, "program"), this.acceptKey(t, "inverse");
            }
            function r(t) {
                this.acceptRequired(t, "name"), this.acceptArray(t.params), this.acceptKey(t, "hash");
            }
            var a = i(1).default;
            e.__esModule = !0;
            var l = a(i(6));
            (s.prototype = {
                constructor: s,
                mutating: !1,
                acceptKey: function (t, e) {
                    var i = this.accept(t[e]);
                    if (this.mutating) {
                        if (i && !s.prototype[i.type]) throw new l.default('Unexpected node type "' + i.type + '" found when accepting ' + e + " on " + t.type);
                        t[e] = i;
                    }
                },
                acceptRequired: function (t, e) {
                    if ((this.acceptKey(t, e), !t[e])) throw new l.default(t.type + " requires " + e);
                },
                acceptArray: function (t) {
                    for (var e = 0, i = t.length; e < i; e++) this.acceptKey(t, e), t[e] || (t.splice(e, 1), e--, i--);
                },
                accept: function (t) {
                    if (t) {
                        if (!this[t.type]) throw new l.default("Unknown type: " + t.type, t);
                        this.current && this.parents.unshift(this.current);
                        var e = this[(this.current = t).type](t);
                        return (this.current = this.parents.shift()), !this.mutating || e ? e : !1 !== e ? t : void 0;
                    }
                },
                Program: function (t) {
                    this.acceptArray(t.body);
                },
                MustacheStatement: o,
                Decorator: o,
                BlockStatement: n,
                DecoratorBlock: n,
                PartialStatement: r,
                PartialBlockStatement: function (t) {
                    r.call(this, t), this.acceptKey(t, "program");
                },
                ContentStatement: function () {},
                CommentStatement: function () {},
                SubExpression: o,
                PathExpression: function () {},
                StringLiteral: function () {},
                NumberLiteral: function () {},
                BooleanLiteral: function () {},
                UndefinedLiteral: function () {},
                NullLiteral: function () {},
                Hash: function (t) {
                    this.acceptArray(t.pairs);
                },
                HashPair: function (t) {
                    this.acceptRequired(t, "value");
                },
            }),
                (e.default = s),
                (t.exports = e.default);
        },
        function (t, e, i) {
            "use strict";
            function c(t, e) {
                if (((e = e.path ? e.path.original : e), t.path.original !== e)) {
                    var i = { loc: t.path.loc };
                    throw new p.default(t.path.original + " doesn't match " + e, i);
                }
            }
            var s = i(1).default;
            (e.__esModule = !0),
                (e.SourceLocation = function (t, e) {
                    (this.source = t), (this.start = { line: e.first_line, column: e.first_column }), (this.end = { line: e.last_line, column: e.last_column });
                }),
                (e.id = function (t) {
                    return /^\[.*\]$/.test(t) ? t.substr(1, t.length - 2) : t;
                }),
                (e.stripFlags = function (t, e) {
                    return { open: "~" === t.charAt(2), close: "~" === e.charAt(e.length - 3) };
                }),
                (e.stripComment = function (t) {
                    return t.replace(/^\{\{~?\!-?-?/, "").replace(/-?-?~?\}\}$/, "");
                }),
                (e.preparePath = function (t, e, i) {
                    i = this.locInfo(i);
                    for (var s = t ? "@" : "", o = [], n = 0, r = 0, a = e.length; r < a; r++) {
                        var l = e[r].part,
                            c = e[r].original !== l;
                        if (((s += (e[r].separator || "") + l), c || (".." !== l && "." !== l && "this" !== l))) o.push(l);
                        else {
                            if (0 < o.length) throw new p.default("Invalid path: " + s, { loc: i });
                            ".." === l && n++;
                        }
                    }
                    return { type: "PathExpression", data: t, depth: n, parts: o, original: s, loc: i };
                }),
                (e.prepareMustache = function (t, e, i, s, o, n) {
                    var r = s.charAt(3) || s.charAt(2),
                        a = "{" !== r && "&" !== r;
                    return { type: /\*/.test(s) ? "Decorator" : "MustacheStatement", path: t, params: e, hash: i, escaped: a, strip: o, loc: this.locInfo(n) };
                }),
                (e.prepareRawBlock = function (t, e, i, s) {
                    c(t, i);
                    var o = { type: "Program", body: e, strip: {}, loc: (s = this.locInfo(s)) };
                    return { type: "BlockStatement", path: t.path, params: t.params, hash: t.hash, program: o, openStrip: {}, inverseStrip: {}, closeStrip: {}, loc: s };
                }),
                (e.prepareBlock = function (t, e, i, s, o, n) {
                    s && s.path && c(t, s);
                    var r = /\*/.test(t.open);
                    e.blockParams = t.blockParams;
                    var a = void 0,
                        l = void 0;
                    if (i) {
                        if (r) throw new p.default("Unexpected inverse block on decorator", i);
                        i.chain && (i.program.body[0].closeStrip = s.strip), (l = i.strip), (a = i.program);
                    }
                    return (
                        o && ((o = a), (a = e), (e = o)),
                        { type: r ? "DecoratorBlock" : "BlockStatement", path: t.path, params: t.params, hash: t.hash, program: e, inverse: a, openStrip: t.strip, inverseStrip: l, closeStrip: s && s.strip, loc: this.locInfo(n) }
                    );
                }),
                (e.prepareProgram = function (t, e) {
                    if (!e && t.length) {
                        var i = t[0].loc,
                            s = t[t.length - 1].loc;
                        i && s && (e = { source: i.source, start: { line: i.start.line, column: i.start.column }, end: { line: s.end.line, column: s.end.column } });
                    }
                    return { type: "Program", body: t, strip: {}, loc: e };
                }),
                (e.preparePartialBlock = function (t, e, i, s) {
                    return c(t, i), { type: "PartialBlockStatement", name: t.path, params: t.params, hash: t.hash, program: e, openStrip: t.strip, closeStrip: i && i.strip, loc: this.locInfo(s) };
                });
            var p = s(i(6));
        },
        function (t, e, i) {
            "use strict";
            function s() {}
            function n(t, e) {
                if (t === e) return !0;
                if (a.isArray(t) && a.isArray(e) && t.length === e.length) {
                    for (var i = 0; i < t.length; i++) if (!n(t[i], e[i])) return !1;
                    return !0;
                }
            }
            function o(t) {
                if (!t.path.parts) {
                    var e = t.path;
                    t.path = { type: "PathExpression", data: !1, depth: 0, parts: [e.original + ""], original: e.original + "", loc: e.loc };
                }
            }
            var r = i(1).default;
            (e.__esModule = !0),
                (e.Compiler = s),
                (e.precompile = function (t, e, i) {
                    if (null == t || ("string" != typeof t && "Program" !== t.type)) throw new l.default("You must pass a string or Handlebars AST to Handlebars.precompile. You passed " + t);
                    "data" in (e = e || {}) || (e.data = !0), e.compat && (e.useDepths = !0);
                    var s = i.parse(t, e),
                        o = new i.Compiler().compile(s, e);
                    return new i.JavaScriptCompiler().compile(o, e);
                }),
                (e.compile = function (s, o, n) {
                    function r() {
                        var t = n.parse(s, o),
                            e = new n.Compiler().compile(t, o),
                            i = new n.JavaScriptCompiler().compile(e, o, void 0, !0);
                        return n.template(i);
                    }
                    function t(t, e) {
                        return a || (a = r()), a.call(this, t, e);
                    }
                    if ((void 0 === o && (o = {}), null == s || ("string" != typeof s && "Program" !== s.type))) throw new l.default("You must pass a string or Handlebars AST to Handlebars.compile. You passed " + s);
                    "data" in o || (o.data = !0), o.compat && (o.useDepths = !0);
                    var a = void 0;
                    return (
                        (t._setup = function (t) {
                            return a || (a = r()), a._setup(t);
                        }),
                        (t._child = function (t, e, i, s) {
                            return a || (a = r()), a._child(t, e, i, s);
                        }),
                        t
                    );
                });
            var l = r(i(6)),
                a = i(5),
                c = r(i(21)),
                p = [].slice;
            s.prototype = {
                compiler: s,
                equals: function (t) {
                    var e = this.opcodes.length;
                    if (t.opcodes.length !== e) return !1;
                    for (var i = 0; i < e; i++) {
                        var s = this.opcodes[i],
                            o = t.opcodes[i];
                        if (s.opcode !== o.opcode || !n(s.args, o.args)) return !1;
                    }
                    for (e = this.children.length, i = 0; i < e; i++) if (!this.children[i].equals(t.children[i])) return !1;
                    return !0;
                },
                guid: 0,
                compile: function (t, e) {
                    (this.sourceNode = []), (this.opcodes = []), (this.children = []), (this.options = e), (this.stringParams = e.stringParams), (this.trackIds = e.trackIds), (e.blockParams = e.blockParams || []);
                    var i = e.knownHelpers;
                    if (((e.knownHelpers = { helperMissing: !0, blockHelperMissing: !0, each: !0, if: !0, unless: !0, with: !0, log: !0, lookup: !0 }), i)) for (var s in i) s in i && (e.knownHelpers[s] = i[s]);
                    return this.accept(t);
                },
                compileProgram: function (t) {
                    var e = new this.compiler().compile(t, this.options),
                        i = this.guid++;
                    return (this.usePartial = this.usePartial || e.usePartial), (this.children[i] = e), (this.useDepths = this.useDepths || e.useDepths), i;
                },
                accept: function (t) {
                    if (!this[t.type]) throw new l.default("Unknown type: " + t.type, t);
                    this.sourceNode.unshift(t);
                    var e = this[t.type](t);
                    return this.sourceNode.shift(), e;
                },
                Program: function (t) {
                    this.options.blockParams.unshift(t.blockParams);
                    for (var e = t.body, i = e.length, s = 0; s < i; s++) this.accept(e[s]);
                    return this.options.blockParams.shift(), (this.isSimple = 1 === i), (this.blockParams = t.blockParams ? t.blockParams.length : 0), this;
                },
                BlockStatement: function (t) {
                    o(t);
                    var e = t.program,
                        i = t.inverse;
                    (e = e && this.compileProgram(e)), (i = i && this.compileProgram(i));
                    var s = this.classifySexpr(t);
                    "helper" === s
                        ? this.helperSexpr(t, e, i)
                        : "simple" === s
                        ? (this.simpleSexpr(t), this.opcode("pushProgram", e), this.opcode("pushProgram", i), this.opcode("emptyHash"), this.opcode("blockValue", t.path.original))
                        : (this.ambiguousSexpr(t, e, i), this.opcode("pushProgram", e), this.opcode("pushProgram", i), this.opcode("emptyHash"), this.opcode("ambiguousBlockValue")),
                        this.opcode("append");
                },
                DecoratorBlock: function (t) {
                    var e = t.program && this.compileProgram(t.program),
                        i = this.setupFullMustacheParams(t, e, void 0),
                        s = t.path;
                    (this.useDecorators = !0), this.opcode("registerDecorator", i.length, s.original);
                },
                PartialStatement: function (t) {
                    this.usePartial = !0;
                    var e = t.program;
                    e && (e = this.compileProgram(t.program));
                    var i = t.params;
                    if (1 < i.length) throw new l.default("Unsupported number of partial arguments: " + i.length, t);
                    i.length || (this.options.explicitPartialContext ? this.opcode("pushLiteral", "undefined") : i.push({ type: "PathExpression", parts: [], depth: 0 }));
                    var s = t.name.original,
                        o = "SubExpression" === t.name.type;
                    o && this.accept(t.name), this.setupFullMustacheParams(t, e, void 0, !0);
                    var n = t.indent || "";
                    this.options.preventIndent && n && (this.opcode("appendContent", n), (n = "")), this.opcode("invokePartial", o, s, n), this.opcode("append");
                },
                PartialBlockStatement: function (t) {
                    this.PartialStatement(t);
                },
                MustacheStatement: function (t) {
                    this.SubExpression(t), t.escaped && !this.options.noEscape ? this.opcode("appendEscaped") : this.opcode("append");
                },
                Decorator: function (t) {
                    this.DecoratorBlock(t);
                },
                ContentStatement: function (t) {
                    t.value && this.opcode("appendContent", t.value);
                },
                CommentStatement: function () {},
                SubExpression: function (t) {
                    o(t);
                    var e = this.classifySexpr(t);
                    "simple" === e ? this.simpleSexpr(t) : "helper" === e ? this.helperSexpr(t) : this.ambiguousSexpr(t);
                },
                ambiguousSexpr: function (t, e, i) {
                    var s = t.path,
                        o = s.parts[0],
                        n = null != e || null != i;
                    this.opcode("getContext", s.depth), this.opcode("pushProgram", e), this.opcode("pushProgram", i), (s.strict = !0), this.accept(s), this.opcode("invokeAmbiguous", o, n);
                },
                simpleSexpr: function (t) {
                    var e = t.path;
                    (e.strict = !0), this.accept(e), this.opcode("resolvePossibleLambda");
                },
                helperSexpr: function (t, e, i) {
                    var s = this.setupFullMustacheParams(t, e, i),
                        o = t.path,
                        n = o.parts[0];
                    if (this.options.knownHelpers[n]) this.opcode("invokeKnownHelper", s.length, n);
                    else {
                        if (this.options.knownHelpersOnly) throw new l.default("You specified knownHelpersOnly, but used the unknown helper " + n, t);
                        (o.strict = !0), (o.falsy = !0), this.accept(o), this.opcode("invokeHelper", s.length, o.original, c.default.helpers.simpleId(o));
                    }
                },
                PathExpression: function (t) {
                    this.addDepth(t.depth), this.opcode("getContext", t.depth);
                    var e = t.parts[0],
                        i = c.default.helpers.scopedId(t),
                        s = !t.depth && !i && this.blockParamIndex(e);
                    s
                        ? this.opcode("lookupBlockParam", s, t.parts)
                        : e
                        ? t.data
                            ? ((this.options.data = !0), this.opcode("lookupData", t.depth, t.parts, t.strict))
                            : this.opcode("lookupOnContext", t.parts, t.falsy, t.strict, i)
                        : this.opcode("pushContext");
                },
                StringLiteral: function (t) {
                    this.opcode("pushString", t.value);
                },
                NumberLiteral: function (t) {
                    this.opcode("pushLiteral", t.value);
                },
                BooleanLiteral: function (t) {
                    this.opcode("pushLiteral", t.value);
                },
                UndefinedLiteral: function () {
                    this.opcode("pushLiteral", "undefined");
                },
                NullLiteral: function () {
                    this.opcode("pushLiteral", "null");
                },
                Hash: function (t) {
                    var e = t.pairs,
                        i = 0,
                        s = e.length;
                    for (this.opcode("pushHash"); i < s; i++) this.pushParam(e[i].value);
                    for (; i--; ) this.opcode("assignToHash", e[i].key);
                    this.opcode("popHash");
                },
                opcode: function (t) {
                    this.opcodes.push({ opcode: t, args: p.call(arguments, 1), loc: this.sourceNode[0].loc });
                },
                addDepth: function (t) {
                    t && (this.useDepths = !0);
                },
                classifySexpr: function (t) {
                    var e = c.default.helpers.simpleId(t.path),
                        i = e && !!this.blockParamIndex(t.path.parts[0]),
                        s = !i && c.default.helpers.helperExpression(t),
                        o = !i && (s || e);
                    if (o && !s) {
                        var n = t.path.parts[0],
                            r = this.options;
                        r.knownHelpers[n] ? (s = !0) : r.knownHelpersOnly && (o = !1);
                    }
                    return s ? "helper" : o ? "ambiguous" : "simple";
                },
                pushParams: function (t) {
                    for (var e = 0, i = t.length; e < i; e++) this.pushParam(t[e]);
                },
                pushParam: function (t) {
                    var e = null != t.value ? t.value : t.original || "";
                    if (this.stringParams)
                        e.replace && (e = e.replace(/^(\.?\.\/)*/g, "").replace(/\//g, ".")),
                            t.depth && this.addDepth(t.depth),
                            this.opcode("getContext", t.depth || 0),
                            this.opcode("pushStringParam", e, t.type),
                            "SubExpression" === t.type && this.accept(t);
                    else {
                        if (this.trackIds) {
                            var i = void 0;
                            if ((!t.parts || c.default.helpers.scopedId(t) || t.depth || (i = this.blockParamIndex(t.parts[0])), i)) {
                                var s = t.parts.slice(1).join(".");
                                this.opcode("pushId", "BlockParam", i, s);
                            } else
                                (e = t.original || e).replace &&
                                    (e = e
                                        .replace(/^this(?:\.|$)/, "")
                                        .replace(/^\.\//, "")
                                        .replace(/^\.$/, "")),
                                    this.opcode("pushId", t.type, e);
                        }
                        this.accept(t);
                    }
                },
                setupFullMustacheParams: function (t, e, i, s) {
                    var o = t.params;
                    return this.pushParams(o), this.opcode("pushProgram", e), this.opcode("pushProgram", i), t.hash ? this.accept(t.hash) : this.opcode("emptyHash", s), o;
                },
                blockParamIndex: function (t) {
                    for (var e = 0, i = this.options.blockParams.length; e < i; e++) {
                        var s = this.options.blockParams[e],
                            o = s && a.indexOf(s, t);
                        if (s && 0 <= o) return [e, o];
                    }
                },
            };
        },
        function (t, e, i) {
            "use strict";
            function l(t) {
                this.value = t;
            }
            function o() {}
            var s = i(1).default;
            e.__esModule = !0;
            var n = i(4),
                f = s(i(6)),
                r = i(5),
                a = s(i(29));
            (o.prototype = {
                nameLookup: function (t, e) {
                    return o.isValidJavaScriptVariableName(e) ? [t, ".", e] : [t, "[", JSON.stringify(e), "]"];
                },
                depthedLookup: function (t) {
                    return [this.aliasable("container.lookup"), '(depths, "', t, '")'];
                },
                compilerInfo: function () {
                    var t = n.COMPILER_REVISION;
                    return [t, n.REVISION_CHANGES[t]];
                },
                appendToBuffer: function (t, e, i) {
                    return r.isArray(t) || (t = [t]), (t = this.source.wrap(t, e)), this.environment.isSimple ? ["return ", t, ";"] : i ? ["buffer += ", t, ";"] : ((t.appendToBuffer = !0), t);
                },
                initializeBuffer: function () {
                    return this.quotedString("");
                },
                compile: function (t, e, i, s) {
                    (this.environment = t),
                        (this.options = e),
                        (this.stringParams = this.options.stringParams),
                        (this.trackIds = this.options.trackIds),
                        (this.precompile = !s),
                        (this.name = this.environment.name),
                        (this.isChild = !!i),
                        (this.context = i || { decorators: [], programs: [], environments: [] }),
                        this.preamble(),
                        (this.stackSlot = 0),
                        (this.stackVars = []),
                        (this.aliases = {}),
                        (this.registers = { list: [] }),
                        (this.hashes = []),
                        (this.compileStack = []),
                        (this.inlineStack = []),
                        (this.blockParams = []),
                        this.compileChildren(t, e),
                        (this.useDepths = this.useDepths || t.useDepths || t.useDecorators || this.options.compat),
                        (this.useBlockParams = this.useBlockParams || t.useBlockParams);
                    var o = t.opcodes,
                        n = void 0,
                        r = void 0,
                        a = void 0,
                        l = void 0;
                    for (a = 0, l = o.length; a < l; a++) (n = o[a]), (this.source.currentLocation = n.loc), (r = r || n.loc), this[n.opcode].apply(this, n.args);
                    if (((this.source.currentLocation = r), this.pushSource(""), this.stackSlot || this.inlineStack.length || this.compileStack.length)) throw new f.default("Compile completed with content left on stack");
                    this.decorators.isEmpty()
                        ? (this.decorators = void 0)
                        : ((this.useDecorators = !0),
                          this.decorators.prepend("var decorators = container.decorators;\n"),
                          this.decorators.push("return fn;"),
                          s
                              ? (this.decorators = Function.apply(this, ["fn", "props", "container", "depth0", "data", "blockParams", "depths", this.decorators.merge()]))
                              : (this.decorators.prepend("function(fn, props, container, depth0, data, blockParams, depths) {\n"), this.decorators.push("}\n"), (this.decorators = this.decorators.merge())));
                    var c = this.createFunctionContext(s);
                    if (this.isChild) return c;
                    var p = { compiler: this.compilerInfo(), main: c };
                    this.decorators && ((p.main_d = this.decorators), (p.useDecorators = !0));
                    var d = this.context,
                        h = d.programs,
                        u = d.decorators;
                    for (a = 0, l = h.length; a < l; a++) h[a] && ((p[a] = h[a]), u[a] && ((p[a + "_d"] = u[a]), (p.useDecorators = !0)));
                    return (
                        this.environment.usePartial && (p.usePartial = !0),
                        this.options.data && (p.useData = !0),
                        this.useDepths && (p.useDepths = !0),
                        this.useBlockParams && (p.useBlockParams = !0),
                        this.options.compat && (p.compat = !0),
                        s
                            ? (p.compilerOptions = this.options)
                            : ((p.compiler = JSON.stringify(p.compiler)),
                              (this.source.currentLocation = { start: { line: 1, column: 0 } }),
                              (p = this.objectLiteral(p)),
                              e.srcName ? ((p = p.toStringWithSourceMap({ file: e.destName })).map = p.map && p.map.toString()) : (p = p.toString())),
                        p
                    );
                },
                preamble: function () {
                    (this.lastContext = 0), (this.source = new a.default(this.options.srcName)), (this.decorators = new a.default(this.options.srcName));
                },
                createFunctionContext: function (t) {
                    var e = "",
                        i = this.stackVars.concat(this.registers.list);
                    0 < i.length && (e += ", " + i.join(", "));
                    var s = 0;
                    for (var o in this.aliases) {
                        var n = this.aliases[o];
                        this.aliases.hasOwnProperty(o) && n.children && 1 < n.referenceCount && ((e += ", alias" + ++s + "=" + o), (n.children[0] = "alias" + s));
                    }
                    var r = ["container", "depth0", "helpers", "partials", "data"];
                    (this.useBlockParams || this.useDepths) && r.push("blockParams"), this.useDepths && r.push("depths");
                    var a = this.mergeSource(e);
                    return t ? (r.push(a), Function.apply(this, r)) : this.source.wrap(["function(", r.join(","), ") {\n  ", a, "}"]);
                },
                mergeSource: function (t) {
                    var e = this.environment.isSimple,
                        i = !this.forceBuffer,
                        s = void 0,
                        o = void 0,
                        n = void 0,
                        r = void 0;
                    return (
                        this.source.each(function (t) {
                            t.appendToBuffer ? (n ? t.prepend("  + ") : (n = t), (r = t)) : (n && (o ? n.prepend("buffer += ") : (s = !0), r.add(";"), (n = r = void 0)), (o = !0), e || (i = !1));
                        }),
                        i
                            ? n
                                ? (n.prepend("return "), r.add(";"))
                                : o || this.source.push('return "";')
                            : ((t += ", buffer = " + (s ? "" : this.initializeBuffer())), n ? (n.prepend("return buffer + "), r.add(";")) : this.source.push("return buffer;")),
                        t && this.source.prepend("var " + t.substring(2) + (s ? "" : ";\n")),
                        this.source.merge()
                    );
                },
                blockValue: function (t) {
                    var e = this.aliasable("helpers.blockHelperMissing"),
                        i = [this.contextName(0)];
                    this.setupHelperArgs(t, 0, i);
                    var s = this.popStack();
                    i.splice(1, 0, s), this.push(this.source.functionCall(e, "call", i));
                },
                ambiguousBlockValue: function () {
                    var t = this.aliasable("helpers.blockHelperMissing"),
                        e = [this.contextName(0)];
                    this.setupHelperArgs("", 0, e, !0), this.flushInline();
                    var i = this.topStack();
                    e.splice(1, 0, i), this.pushSource(["if (!", this.lastHelper, ") { ", i, " = ", this.source.functionCall(t, "call", e), "}"]);
                },
                appendContent: function (t) {
                    this.pendingContent ? (t = this.pendingContent + t) : (this.pendingLocation = this.source.currentLocation), (this.pendingContent = t);
                },
                append: function () {
                    if (this.isInline())
                        this.replaceStack(function (t) {
                            return [" != null ? ", t, ' : ""'];
                        }),
                            this.pushSource(this.appendToBuffer(this.popStack()));
                    else {
                        var t = this.popStack();
                        this.pushSource(["if (", t, " != null) { ", this.appendToBuffer(t, void 0, !0), " }"]), this.environment.isSimple && this.pushSource(["else { ", this.appendToBuffer("''", void 0, !0), " }"]);
                    }
                },
                appendEscaped: function () {
                    this.pushSource(this.appendToBuffer([this.aliasable("container.escapeExpression"), "(", this.popStack(), ")"]));
                },
                getContext: function (t) {
                    this.lastContext = t;
                },
                pushContext: function () {
                    this.pushStackLiteral(this.contextName(this.lastContext));
                },
                lookupOnContext: function (t, e, i, s) {
                    var o = 0;
                    s || !this.options.compat || this.lastContext ? this.pushContext() : this.push(this.depthedLookup(t[o++])), this.resolvePath("context", t, o, e, i);
                },
                lookupBlockParam: function (t, e) {
                    (this.useBlockParams = !0), this.push(["blockParams[", t[0], "][", t[1], "]"]), this.resolvePath("context", e, 1);
                },
                lookupData: function (t, e, i) {
                    t ? this.pushStackLiteral("container.data(data, " + t + ")") : this.pushStackLiteral("data"), this.resolvePath("data", e, 0, !0, i);
                },
                resolvePath: function (i, s, o, n, t) {
                    var r = this;
                    if (this.options.strict || this.options.assumeObjects)
                        this.push(
                            (function (t, e, i, s) {
                                var o = e.popStack(),
                                    n = 0,
                                    r = i.length;
                                for (t && r--; n < r; n++) o = e.nameLookup(o, i[n], s);
                                return t ? [e.aliasable("container.strict"), "(", o, ", ", e.quotedString(i[n]), ")"] : o;
                            })(this.options.strict && t, this, s, i)
                        );
                    else
                        for (var e = s.length; o < e; o++)
                            this.replaceStack(function (t) {
                                var e = r.nameLookup(t, s[o], i);
                                return n ? [" && ", e] : [" != null ? ", e, " : ", t];
                            });
                },
                resolvePossibleLambda: function () {
                    this.push([this.aliasable("container.lambda"), "(", this.popStack(), ", ", this.contextName(0), ")"]);
                },
                pushStringParam: function (t, e) {
                    this.pushContext(), this.pushString(e), "SubExpression" !== e && ("string" == typeof t ? this.pushString(t) : this.pushStackLiteral(t));
                },
                emptyHash: function (t) {
                    this.trackIds && this.push("{}"), this.stringParams && (this.push("{}"), this.push("{}")), this.pushStackLiteral(t ? "undefined" : "{}");
                },
                pushHash: function () {
                    this.hash && this.hashes.push(this.hash), (this.hash = { values: [], types: [], contexts: [], ids: [] });
                },
                popHash: function () {
                    var t = this.hash;
                    (this.hash = this.hashes.pop()),
                        this.trackIds && this.push(this.objectLiteral(t.ids)),
                        this.stringParams && (this.push(this.objectLiteral(t.contexts)), this.push(this.objectLiteral(t.types))),
                        this.push(this.objectLiteral(t.values));
                },
                pushString: function (t) {
                    this.pushStackLiteral(this.quotedString(t));
                },
                pushLiteral: function (t) {
                    this.pushStackLiteral(t);
                },
                pushProgram: function (t) {
                    null != t ? this.pushStackLiteral(this.programExpression(t)) : this.pushStackLiteral(null);
                },
                registerDecorator: function (t, e) {
                    var i = this.nameLookup("decorators", e, "decorator"),
                        s = this.setupHelperArgs(e, t);
                    this.decorators.push(["fn = ", this.decorators.functionCall(i, "", ["fn", "props", "container", s]), " || fn;"]);
                },
                invokeHelper: function (t, e, i) {
                    var s = this.popStack(),
                        o = this.setupHelper(t, e),
                        n = i ? [o.name, " || "] : "",
                        r = ["("].concat(n, s);
                    this.options.strict || r.push(" || ", this.aliasable("helpers.helperMissing")), r.push(")"), this.push(this.source.functionCall(r, "call", o.callParams));
                },
                invokeKnownHelper: function (t, e) {
                    var i = this.setupHelper(t, e);
                    this.push(this.source.functionCall(i.name, "call", i.callParams));
                },
                invokeAmbiguous: function (t, e) {
                    this.useRegister("helper");
                    var i = this.popStack();
                    this.emptyHash();
                    var s = this.setupHelper(0, t, e),
                        o = ["(", "(helper = ", (this.lastHelper = this.nameLookup("helpers", t, "helper")), " || ", i, ")"];
                    this.options.strict || ((o[0] = "(helper = "), o.push(" != null ? helper : ", this.aliasable("helpers.helperMissing"))),
                        this.push(["(", o, s.paramsInit ? ["),(", s.paramsInit] : [], "),", "(typeof helper === ", this.aliasable('"function"'), " ? ", this.source.functionCall("helper", "call", s.callParams), " : helper))"]);
                },
                invokePartial: function (t, e, i) {
                    var s = [],
                        o = this.setupParams(e, 1, s);
                    t && ((e = this.popStack()), delete o.name),
                        i && (o.indent = JSON.stringify(i)),
                        (o.helpers = "helpers"),
                        (o.partials = "partials"),
                        (o.decorators = "container.decorators"),
                        t ? s.unshift(e) : s.unshift(this.nameLookup("partials", e, "partial")),
                        this.options.compat && (o.depths = "depths"),
                        (o = this.objectLiteral(o)),
                        s.push(o),
                        this.push(this.source.functionCall("container.invokePartial", "", s));
                },
                assignToHash: function (t) {
                    var e = this.popStack(),
                        i = void 0,
                        s = void 0,
                        o = void 0;
                    this.trackIds && (o = this.popStack()), this.stringParams && ((s = this.popStack()), (i = this.popStack()));
                    var n = this.hash;
                    i && (n.contexts[t] = i), s && (n.types[t] = s), o && (n.ids[t] = o), (n.values[t] = e);
                },
                pushId: function (t, e, i) {
                    "BlockParam" === t
                        ? this.pushStackLiteral("blockParams[" + e[0] + "].path[" + e[1] + "]" + (i ? " + " + JSON.stringify("." + i) : ""))
                        : "PathExpression" === t
                        ? this.pushString(e)
                        : "SubExpression" === t
                        ? this.pushStackLiteral("true")
                        : this.pushStackLiteral("null");
                },
                compiler: o,
                compileChildren: function (t, e) {
                    for (var i = t.children, s = void 0, o = void 0, n = 0, r = i.length; n < r; n++) {
                        (s = i[n]), (o = new this.compiler());
                        var a = this.matchExistingProgram(s);
                        null == a
                            ? (this.context.programs.push(""),
                              (a = this.context.programs.length),
                              (s.index = a),
                              (s.name = "program" + a),
                              (this.context.programs[a] = o.compile(s, e, this.context, !this.precompile)),
                              (this.context.decorators[a] = o.decorators),
                              (this.context.environments[a] = s),
                              (this.useDepths = this.useDepths || o.useDepths),
                              (this.useBlockParams = this.useBlockParams || o.useBlockParams))
                            : ((s.index = a), (s.name = "program" + a), (this.useDepths = this.useDepths || s.useDepths), (this.useBlockParams = this.useBlockParams || s.useBlockParams));
                    }
                },
                matchExistingProgram: function (t) {
                    for (var e = 0, i = this.context.environments.length; e < i; e++) {
                        var s = this.context.environments[e];
                        if (s && s.equals(t)) return e;
                    }
                },
                programExpression: function (t) {
                    var e = this.environment.children[t],
                        i = [e.index, "data", e.blockParams];
                    return (this.useBlockParams || this.useDepths) && i.push("blockParams"), this.useDepths && i.push("depths"), "container.program(" + i.join(", ") + ")";
                },
                useRegister: function (t) {
                    this.registers[t] || ((this.registers[t] = !0), this.registers.list.push(t));
                },
                push: function (t) {
                    return t instanceof l || (t = this.source.wrap(t)), this.inlineStack.push(t), t;
                },
                pushStackLiteral: function (t) {
                    this.push(new l(t));
                },
                pushSource: function (t) {
                    this.pendingContent && (this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent), this.pendingLocation)), (this.pendingContent = void 0)), t && this.source.push(t);
                },
                replaceStack: function (t) {
                    var e = ["("],
                        i = void 0,
                        s = void 0,
                        o = void 0;
                    if (!this.isInline()) throw new f.default("replaceStack on non-inline");
                    var n = this.popStack(!0);
                    if (n instanceof l) (e = ["(", (i = [n.value])]), (o = !0);
                    else {
                        s = !0;
                        var r = this.incrStack();
                        (e = ["((", this.push(r), " = ", n, ")"]), (i = this.topStack());
                    }
                    var a = t.call(this, i);
                    o || this.popStack(), s && this.stackSlot--, this.push(e.concat(a, ")"));
                },
                incrStack: function () {
                    return this.stackSlot++, this.stackSlot > this.stackVars.length && this.stackVars.push("stack" + this.stackSlot), this.topStackName();
                },
                topStackName: function () {
                    return "stack" + this.stackSlot;
                },
                flushInline: function () {
                    var t = this.inlineStack;
                    this.inlineStack = [];
                    for (var e = 0, i = t.length; e < i; e++) {
                        var s = t[e];
                        if (s instanceof l) this.compileStack.push(s);
                        else {
                            var o = this.incrStack();
                            this.pushSource([o, " = ", s, ";"]), this.compileStack.push(o);
                        }
                    }
                },
                isInline: function () {
                    return this.inlineStack.length;
                },
                popStack: function (t) {
                    var e = this.isInline(),
                        i = (e ? this.inlineStack : this.compileStack).pop();
                    if (!t && i instanceof l) return i.value;
                    if (!e) {
                        if (!this.stackSlot) throw new f.default("Invalid stack pop");
                        this.stackSlot--;
                    }
                    return i;
                },
                topStack: function () {
                    var t = this.isInline() ? this.inlineStack : this.compileStack,
                        e = t[t.length - 1];
                    return e instanceof l ? e.value : e;
                },
                contextName: function (t) {
                    return this.useDepths && t ? "depths[" + t + "]" : "depth" + t;
                },
                quotedString: function (t) {
                    return this.source.quotedString(t);
                },
                objectLiteral: function (t) {
                    return this.source.objectLiteral(t);
                },
                aliasable: function (t) {
                    var e = this.aliases[t];
                    return e ? e.referenceCount++ : (((e = this.aliases[t] = this.source.wrap(t)).aliasable = !0), (e.referenceCount = 1)), e;
                },
                setupHelper: function (t, e, i) {
                    var s = [];
                    return {
                        params: s,
                        paramsInit: this.setupHelperArgs(e, t, s, i),
                        name: this.nameLookup("helpers", e, "helper"),
                        callParams: [this.aliasable(this.contextName(0) + " != null ? " + this.contextName(0) + " : {}")].concat(s),
                    };
                },
                setupParams: function (t, e, i) {
                    var s = {},
                        o = [],
                        n = [],
                        r = [],
                        a = !i,
                        l = void 0;
                    a && (i = []), (s.name = this.quotedString(t)), (s.hash = this.popStack()), this.trackIds && (s.hashIds = this.popStack()), this.stringParams && ((s.hashTypes = this.popStack()), (s.hashContexts = this.popStack()));
                    var c = this.popStack(),
                        p = this.popStack();
                    (p || c) && ((s.fn = p || "container.noop"), (s.inverse = c || "container.noop"));
                    for (var d = e; d--; ) (l = this.popStack()), (i[d] = l), this.trackIds && (r[d] = this.popStack()), this.stringParams && ((n[d] = this.popStack()), (o[d] = this.popStack()));
                    return (
                        a && (s.args = this.source.generateArray(i)),
                        this.trackIds && (s.ids = this.source.generateArray(r)),
                        this.stringParams && ((s.types = this.source.generateArray(n)), (s.contexts = this.source.generateArray(o))),
                        this.options.data && (s.data = "data"),
                        this.useBlockParams && (s.blockParams = "blockParams"),
                        s
                    );
                },
                setupHelperArgs: function (t, e, i, s) {
                    var o = this.setupParams(t, e, i);
                    return (o = this.objectLiteral(o)), s ? (this.useRegister("options"), i.push("options"), ["options=", o]) : i ? (i.push(o), "") : o;
                },
            }),
                (function () {
                    for (
                        var t = "break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false".split(
                                " "
                            ),
                            e = (o.RESERVED_WORDS = {}),
                            i = 0,
                            s = t.length;
                        i < s;
                        i++
                    )
                        e[t[i]] = !0;
                })(),
                (o.isValidJavaScriptVariableName = function (t) {
                    return !o.RESERVED_WORDS[t] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(t);
                }),
                (e.default = o),
                (t.exports = e.default);
        },
        function (t, e, i) {
            "use strict";
            function n(t, e, i) {
                if (r.isArray(t)) {
                    for (var s = [], o = 0, n = t.length; o < n; o++) s.push(e.wrap(t[o], i));
                    return s;
                }
                return "boolean" == typeof t || "number" == typeof t ? t + "" : t;
            }
            function s(t) {
                (this.srcFile = t), (this.source = []);
            }
            e.__esModule = !0;
            var r = i(5),
                o = void 0;
            o ||
                ((o = function (t, e, i, s) {
                    (this.src = ""), s && this.add(s);
                }).prototype = {
                    add: function (t) {
                        r.isArray(t) && (t = t.join("")), (this.src += t);
                    },
                    prepend: function (t) {
                        r.isArray(t) && (t = t.join("")), (this.src = t + this.src);
                    },
                    toStringWithSourceMap: function () {
                        return { code: this.toString() };
                    },
                    toString: function () {
                        return this.src;
                    },
                }),
                (s.prototype = {
                    isEmpty: function () {
                        return !this.source.length;
                    },
                    prepend: function (t, e) {
                        this.source.unshift(this.wrap(t, e));
                    },
                    push: function (t, e) {
                        this.source.push(this.wrap(t, e));
                    },
                    merge: function () {
                        var e = this.empty();
                        return (
                            this.each(function (t) {
                                e.add(["  ", t, "\n"]);
                            }),
                            e
                        );
                    },
                    each: function (t) {
                        for (var e = 0, i = this.source.length; e < i; e++) t(this.source[e]);
                    },
                    empty: function () {
                        var t = this.currentLocation || { start: {} };
                        return new o(t.start.line, t.start.column, this.srcFile);
                    },
                    wrap: function (t) {
                        var e = arguments.length <= 1 || void 0 === arguments[1] ? this.currentLocation || { start: {} } : arguments[1];
                        return t instanceof o ? t : ((t = n(t, this, e)), new o(e.start.line, e.start.column, this.srcFile, t));
                    },
                    functionCall: function (t, e, i) {
                        return (i = this.generateList(i)), this.wrap([t, e ? "." + e + "(" : "(", i, ")"]);
                    },
                    quotedString: function (t) {
                        return (
                            '"' +
                            (t + "")
                                .replace(/\\/g, "\\\\")
                                .replace(/"/g, '\\"')
                                .replace(/\n/g, "\\n")
                                .replace(/\r/g, "\\r")
                                .replace(/\u2028/g, "\\u2028")
                                .replace(/\u2029/g, "\\u2029") +
                            '"'
                        );
                    },
                    objectLiteral: function (t) {
                        var e = [];
                        for (var i in t)
                            if (t.hasOwnProperty(i)) {
                                var s = n(t[i], this);
                                "undefined" !== s && e.push([this.quotedString(i), ":", s]);
                            }
                        var o = this.generateList(e);
                        return o.prepend("{"), o.add("}"), o;
                    },
                    generateList: function (t) {
                        for (var e = this.empty(), i = 0, s = t.length; i < s; i++) i && e.add(","), e.add(n(t[i], this));
                        return e;
                    },
                    generateArray: function (t) {
                        var e = this.generateList(t);
                        return e.prepend("["), e.add("]"), e;
                    },
                }),
                (e.default = s),
                (t.exports = e.default);
        },
    ]);
}),
    (function (t) {
        "use strict";
        "function" == typeof define && define.amd ? define(["jquery"], t) : t(jQuery);
    })(function (o) {
        "use strict";
        var n = [],
            e = [],
            s = { precision: 100, elapse: !1 };
        e.push(/^[0-9]*$/.source), e.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source), e.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source), (e = new RegExp(e.join("|")));
        var m = { Y: "years", m: "months", n: "daysToMonth", w: "weeks", d: "daysToWeek", D: "totalDays", H: "hours", M: "minutes", S: "seconds" },
            r = function (t, e, i) {
                (this.el = t),
                    (this.$el = o(t)),
                    (this.interval = null),
                    (this.offset = {}),
                    (this.options = o.extend({}, s)),
                    (this.instanceNumber = n.length),
                    n.push(this),
                    this.$el.data("countdown-instance", this.instanceNumber),
                    i && ("function" == typeof i ? (this.$el.on("update.countdown", i), this.$el.on("stoped.countdown", i), this.$el.on("finish.countdown", i)) : (this.options = o.extend({}, s, i))),
                    this.setFinalDate(e),
                    this.start();
            };
        o.extend(r.prototype, {
            start: function () {
                null !== this.interval && clearInterval(this.interval);
                var t = this;
                this.update(),
                    (this.interval = setInterval(function () {
                        t.update.call(t);
                    }, this.options.precision));
            },
            stop: function () {
                clearInterval(this.interval), (this.interval = null), this.dispatchEvent("stoped");
            },
            toggle: function () {
                this.interval ? this.stop() : this.start();
            },
            pause: function () {
                this.stop();
            },
            resume: function () {
                this.start();
            },
            remove: function () {
                this.stop.call(this), (n[this.instanceNumber] = null), delete this.$el.data().countdownInstance;
            },
            setFinalDate: function (t) {
                this.finalDate = (function (t) {
                    if (t instanceof Date) return t;
                    if (String(t).match(e)) return String(t).match(/^[0-9]*$/) && (t = Number(t)), String(t).match(/\-/) && (t = String(t).replace(/\-/g, "/")), new Date(t);
                    throw new Error("Couldn't cast `" + t + "` to a date object.");
                })(t);
            },
            update: function () {
                if (0 !== this.$el.closest("html").length) {
                    var t,
                        e = void 0 !== o._data(this.el, "events"),
                        i = new Date();
                    (t = this.finalDate.getTime() - i.getTime()),
                        (t = Math.ceil(t / 1e3)),
                        (t = !this.options.elapse && t < 0 ? 0 : Math.abs(t)),
                        this.totalSecsLeft !== t &&
                            e &&
                            ((this.totalSecsLeft = t),
                            (this.elapsed = i >= this.finalDate),
                            (this.offset = {
                                seconds: this.totalSecsLeft % 60,
                                minutes: Math.floor(this.totalSecsLeft / 60) % 60,
                                hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
                                days: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                                daysToWeek: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                                daysToMonth: Math.floor((this.totalSecsLeft / 60 / 60 / 24) % 30.4368),
                                totalDays: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
                                weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
                                months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30.4368),
                                years: Math.abs(this.finalDate.getFullYear() - i.getFullYear()),
                            }),
                            this.options.elapse || 0 !== this.totalSecsLeft ? this.dispatchEvent("update") : (this.stop(), this.dispatchEvent("finish")));
                } else this.remove();
            },
            dispatchEvent: function (t) {
                var f,
                    e = o.Event(t + ".countdown");
                (e.finalDate = this.finalDate),
                    (e.elapsed = this.elapsed),
                    (e.offset = o.extend({}, this.offset)),
                    (e.strftime =
                        ((f = this.offset),
                        function (t) {
                            var e,
                                i,
                                s,
                                o,
                                n,
                                r = t.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);
                            if (r)
                                for (var a = 0, l = r.length; a < l; ++a) {
                                    var c = r[a].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/),
                                        p = ((n = c[0].toString().replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1")), new RegExp(n)),
                                        d = c[1] || "",
                                        h = c[3] || "",
                                        u = null;
                                    (c = c[2]),
                                        m.hasOwnProperty(c) && ((u = m[c]), (u = Number(f[u]))),
                                        null !== u &&
                                            ("!" === d &&
                                                ((i = u),
                                                (o = s = void 0),
                                                (s = "s"),
                                                (o = ""),
                                                (e = h) && (1 === (e = e.replace(/(:|;|\s)/gi, "").split(/\,/)).length ? (s = e[0]) : ((o = e[0]), (s = e[1]))),
                                                (u = 1 === Math.abs(i) ? o : s)),
                                            "" === d && u < 10 && (u = "0" + u.toString()),
                                            (t = t.replace(p, u.toString())));
                                }
                            return t.replace(/%%/, "%");
                        })),
                    this.$el.trigger(e);
            },
        }),
            (o.fn.countdown = function () {
                var s = Array.prototype.slice.call(arguments, 0);
                return this.each(function () {
                    var t = o(this).data("countdown-instance");
                    if (void 0 !== t) {
                        var e = n[t],
                            i = s[0];
                        r.prototype.hasOwnProperty(i)
                            ? e[i].apply(e, s.slice(1))
                            : null === String(i).match(/^[$A-Z_][0-9A-Z_$]*$/i)
                            ? (e.setFinalDate.call(e, i), e.start())
                            : o.error("Method %s does not exist on jQuery.countdown".replace(/\%s/gi, i));
                    } else new r(this, s[0], s[1]);
                });
            });
    }),
    (function (t) {
        "use strict";
        "function" == typeof define && define.amd ? define(["jquery"], t) : "undefined" != typeof exports ? (module.exports = t(require("jquery"))) : t(jQuery);
    })(function (c) {
        "use strict";
        var o,
            r = window.Slick;
        (o = 0),
            ((r = function (t, e) {
                var i,
                    s = this;
                (s.defaults = {
                    accessibility: !0,
                    adaptiveHeight: !1,
                    appendArrows: c(t),
                    appendDots: c(t),
                    arrows: !0,
                    asNavFor: null,
                    prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
                    nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
                    autoplay: !1,
                    autoplaySpeed: 3e3,
                    centerMode: !1,
                    centerPadding: "50px",
                    cssEase: "ease",
                    customPaging: function (t, e) {
                        return c('<button type="button" data-role="none" role="button" tabindex="0" />').text(e + 1);
                    },
                    dots: !1,
                    dotsClass: "slick-dots",
                    draggable: !0,
                    easing: "linear",
                    edgeFriction: 0.35,
                    fade: !1,
                    focusOnSelect: !1,
                    infinite: !0,
                    initialSlide: 0,
                    lazyLoad: "ondemand",
                    mobileFirst: !1,
                    pauseOnHover: !0,
                    pauseOnFocus: !0,
                    pauseOnDotsHover: !1,
                    respondTo: "window",
                    responsive: null,
                    rows: 1,
                    rtl: !1,
                    slide: "",
                    slidesPerRow: 1,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 500,
                    swipe: !0,
                    swipeToSlide: !1,
                    touchMove: !0,
                    touchThreshold: 5,
                    useCSS: !0,
                    useTransform: !0,
                    variableWidth: !1,
                    vertical: !1,
                    verticalSwiping: !1,
                    waitForAnimate: !0,
                    zIndex: 1e3,
                }),
                    (s.initials = {
                        animating: !1,
                        dragging: !1,
                        autoPlayTimer: null,
                        currentDirection: 0,
                        currentLeft: null,
                        currentSlide: 0,
                        direction: 1,
                        $dots: null,
                        listWidth: null,
                        listHeight: null,
                        loadIndex: 0,
                        $nextArrow: null,
                        $prevArrow: null,
                        slideCount: null,
                        slideWidth: null,
                        $slideTrack: null,
                        $slides: null,
                        sliding: !1,
                        slideOffset: 0,
                        swipeLeft: null,
                        $list: null,
                        touchObject: {},
                        transformsEnabled: !1,
                        unslicked: !1,
                    }),
                    c.extend(s, s.initials),
                    (s.activeBreakpoint = null),
                    (s.animType = null),
                    (s.animProp = null),
                    (s.breakpoints = []),
                    (s.breakpointSettings = []),
                    (s.cssTransitions = !1),
                    (s.focussed = !1),
                    (s.interrupted = !1),
                    (s.hidden = "hidden"),
                    (s.paused = !0),
                    (s.positionProp = null),
                    (s.respondTo = null),
                    (s.rowCount = 1),
                    (s.shouldClick = !0),
                    (s.$slider = c(t)),
                    (s.$slidesCache = null),
                    (s.transformType = null),
                    (s.transitionType = null),
                    (s.visibilityChange = "visibilitychange"),
                    (s.windowWidth = 0),
                    (s.windowTimer = null),
                    (i = c(t).data("slick") || {}),
                    (s.options = c.extend({}, s.defaults, e, i)),
                    (s.currentSlide = s.options.initialSlide),
                    (s.originalSettings = s.options),
                    void 0 !== document.mozHidden
                        ? ((s.hidden = "mozHidden"), (s.visibilityChange = "mozvisibilitychange"))
                        : void 0 !== document.webkitHidden && ((s.hidden = "webkitHidden"), (s.visibilityChange = "webkitvisibilitychange")),
                    (s.autoPlay = c.proxy(s.autoPlay, s)),
                    (s.autoPlayClear = c.proxy(s.autoPlayClear, s)),
                    (s.autoPlayIterator = c.proxy(s.autoPlayIterator, s)),
                    (s.changeSlide = c.proxy(s.changeSlide, s)),
                    (s.clickHandler = c.proxy(s.clickHandler, s)),
                    (s.selectHandler = c.proxy(s.selectHandler, s)),
                    (s.setPosition = c.proxy(s.setPosition, s)),
                    (s.swipeHandler = c.proxy(s.swipeHandler, s)),
                    (s.dragHandler = c.proxy(s.dragHandler, s)),
                    (s.keyHandler = c.proxy(s.keyHandler, s)),
                    (s.instanceUid = o++),
                    (s.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
                    s.registerBreakpoints(),
                    s.init(!0);
            }).prototype.activateADA = function () {
                this.$slideTrack.find(".slick-active").attr({ "aria-hidden": "false" }).find("a, input, button, select").attr({ tabindex: "0" });
            }),
            (r.prototype.addSlide = r.prototype.slickAdd = function (t, e, i) {
                var s = this;
                if ("boolean" == typeof e) (i = e), (e = null);
                else if (e < 0 || e >= s.slideCount) return !1;
                s.unload(),
                    "number" == typeof e
                        ? 0 === e && 0 === s.$slides.length
                            ? c(t).appendTo(s.$slideTrack)
                            : i
                            ? c(t).insertBefore(s.$slides.eq(e))
                            : c(t).insertAfter(s.$slides.eq(e))
                        : !0 === i
                        ? c(t).prependTo(s.$slideTrack)
                        : c(t).appendTo(s.$slideTrack),
                    (s.$slides = s.$slideTrack.children(this.options.slide)),
                    s.$slideTrack.children(this.options.slide).detach(),
                    s.$slideTrack.append(s.$slides),
                    s.$slides.each(function (t, e) {
                        c(e).attr("data-slick-index", t);
                    }),
                    (s.$slidesCache = s.$slides),
                    s.reinit();
            }),
            (r.prototype.animateHeight = function () {
                var t = this;
                if (1 === t.options.slidesToShow && !0 === t.options.adaptiveHeight && !1 === t.options.vertical) {
                    var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
                    t.$list.animate({ height: e }, t.options.speed);
                }
            }),
            (r.prototype.animateSlide = function (t, e) {
                var i = {},
                    s = this;
                s.animateHeight(),
                    !0 === s.options.rtl && !1 === s.options.vertical && (t = -t),
                    !1 === s.transformsEnabled
                        ? !1 === s.options.vertical
                            ? s.$slideTrack.animate({ left: t }, s.options.speed, s.options.easing, e)
                            : s.$slideTrack.animate({ top: t }, s.options.speed, s.options.easing, e)
                        : !1 === s.cssTransitions
                        ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft),
                          c({ animStart: s.currentLeft }).animate(
                              { animStart: t },
                              {
                                  duration: s.options.speed,
                                  easing: s.options.easing,
                                  step: function (t) {
                                      (t = Math.ceil(t)), !1 === s.options.vertical ? (i[s.animType] = "translate(" + t + "px, 0px)") : (i[s.animType] = "translate(0px," + t + "px)"), s.$slideTrack.css(i);
                                  },
                                  complete: function () {
                                      e && e.call();
                                  },
                              }
                          ))
                        : (s.applyTransition(),
                          (t = Math.ceil(t)),
                          !1 === s.options.vertical ? (i[s.animType] = "translate3d(" + t + "px, 0px, 0px)") : (i[s.animType] = "translate3d(0px," + t + "px, 0px)"),
                          s.$slideTrack.css(i),
                          e &&
                              setTimeout(function () {
                                  s.disableTransition(), e.call();
                              }, s.options.speed));
            }),
            (r.prototype.getNavTarget = function () {
                var t = this.options.asNavFor;
                return t && null !== t && (t = c(t).not(this.$slider)), t;
            }),
            (r.prototype.asNavFor = function (e) {
                var t = this.getNavTarget();
                null !== t &&
                    "object" == typeof t &&
                    t.each(function () {
                        var t = c(this).slick("getSlick");
                        t.unslicked || t.slideHandler(e, !0);
                    });
            }),
            (r.prototype.applyTransition = function (t) {
                var e = this,
                    i = {};
                !1 === e.options.fade ? (i[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase) : (i[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase),
                    !1 === e.options.fade ? e.$slideTrack.css(i) : e.$slides.eq(t).css(i);
            }),
            (r.prototype.autoPlay = function () {
                var t = this;
                t.autoPlayClear(), t.slideCount > t.options.slidesToShow && (t.autoPlayTimer = setInterval(t.autoPlayIterator, t.options.autoplaySpeed));
            }),
            (r.prototype.autoPlayClear = function () {
                this.autoPlayTimer && clearInterval(this.autoPlayTimer);
            }),
            (r.prototype.autoPlayIterator = function () {
                var t = this,
                    e = t.currentSlide + t.options.slidesToScroll;
                t.paused ||
                    t.interrupted ||
                    t.focussed ||
                    (!1 === t.options.infinite &&
                        (1 === t.direction && t.currentSlide + 1 === t.slideCount - 1 ? (t.direction = 0) : 0 === t.direction && ((e = t.currentSlide - t.options.slidesToScroll), t.currentSlide - 1 == 0 && (t.direction = 1))),
                    t.slideHandler(e));
            }),
            (r.prototype.buildArrows = function () {
                var t = this;
                !0 === t.options.arrows &&
                    ((t.$prevArrow = c(t.options.prevArrow).addClass("slick-arrow")),
                    (t.$nextArrow = c(t.options.nextArrow).addClass("slick-arrow")),
                    t.slideCount > t.options.slidesToShow
                        ? (t.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                          t.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                          t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.prependTo(t.options.appendArrows),
                          t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.appendTo(t.options.appendArrows),
                          !0 !== t.options.infinite && t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"))
                        : t.$prevArrow.add(t.$nextArrow).addClass("slick-hidden").attr({ "aria-disabled": "true", tabindex: "-1" }));
            }),
            (r.prototype.buildDots = function () {
                var t,
                    e,
                    i = this;
                if (!0 === i.options.dots && i.slideCount > i.options.slidesToShow) {
                    for (i.$slider.addClass("slick-dotted"), e = c("<ul />").addClass(i.options.dotsClass), t = 0; t <= i.getDotCount(); t += 1) e.append(c("<li />").append(i.options.customPaging.call(this, i, t)));
                    (i.$dots = e.appendTo(i.options.appendDots)), i.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false");
                }
            }),
            (r.prototype.buildOut = function () {
                var t = this;
                (t.$slides = t.$slider.children(t.options.slide + ":not(.slick-cloned)").addClass("slick-slide")),
                    (t.slideCount = t.$slides.length),
                    t.$slides.each(function (t, e) {
                        c(e)
                            .attr("data-slick-index", t)
                            .data("originalStyling", c(e).attr("style") || "");
                    }),
                    t.$slider.addClass("slick-slider"),
                    (t.$slideTrack = 0 === t.slideCount ? c('<div class="slick-track"/>').appendTo(t.$slider) : t.$slides.wrapAll('<div class="slick-track"/>').parent()),
                    (t.$list = t.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent()),
                    t.$slideTrack.css("opacity", 0),
                    (!0 === t.options.centerMode || !0 === t.options.swipeToSlide) && (t.options.slidesToScroll = 1),
                    c("img[data-lazy]", t.$slider).not("[src]").addClass("slick-loading"),
                    t.setupInfinite(),
                    t.buildArrows(),
                    t.buildDots(),
                    t.updateDots(),
                    t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0),
                    !0 === t.options.draggable && t.$list.addClass("draggable");
            }),
            (r.prototype.buildRows = function () {
                var t,
                    e,
                    i,
                    s,
                    o,
                    n,
                    r,
                    a = this;
                if (((s = document.createDocumentFragment()), (n = a.$slider.children()), 1 < a.options.rows)) {
                    for (r = a.options.slidesPerRow * a.options.rows, o = Math.ceil(n.length / r), t = 0; t < o; t++) {
                        var l = document.createElement("div");
                        for (e = 0; e < a.options.rows; e++) {
                            var c = document.createElement("div");
                            for (i = 0; i < a.options.slidesPerRow; i++) {
                                var p = t * r + (e * a.options.slidesPerRow + i);
                                n.get(p) && c.appendChild(n.get(p));
                            }
                            l.appendChild(c);
                        }
                        s.appendChild(l);
                    }
                    a.$slider.empty().append(s),
                        a.$slider
                            .children()
                            .children()
                            .children()
                            .css({ width: 100 / a.options.slidesPerRow + "%", display: "inline-block" });
                }
            }),
            (r.prototype.checkResponsive = function (t, e) {
                var i,
                    s,
                    o,
                    n = this,
                    r = !1,
                    a = n.$slider.width(),
                    l = window.innerWidth || c(window).width();
                if (("window" === n.respondTo ? (o = l) : "slider" === n.respondTo ? (o = a) : "min" === n.respondTo && (o = Math.min(l, a)), n.options.responsive && n.options.responsive.length && null !== n.options.responsive)) {
                    for (i in ((s = null), n.breakpoints)) n.breakpoints.hasOwnProperty(i) && (!1 === n.originalSettings.mobileFirst ? o < n.breakpoints[i] && (s = n.breakpoints[i]) : o > n.breakpoints[i] && (s = n.breakpoints[i]));
                    null !== s
                        ? null !== n.activeBreakpoint
                            ? (s !== n.activeBreakpoint || e) &&
                              ((n.activeBreakpoint = s),
                              "unslick" === n.breakpointSettings[s] ? n.unslick(s) : ((n.options = c.extend({}, n.originalSettings, n.breakpointSettings[s])), !0 === t && (n.currentSlide = n.options.initialSlide), n.refresh(t)),
                              (r = s))
                            : ((n.activeBreakpoint = s),
                              "unslick" === n.breakpointSettings[s] ? n.unslick(s) : ((n.options = c.extend({}, n.originalSettings, n.breakpointSettings[s])), !0 === t && (n.currentSlide = n.options.initialSlide), n.refresh(t)),
                              (r = s))
                        : null !== n.activeBreakpoint && ((n.activeBreakpoint = null), (n.options = n.originalSettings), !0 === t && (n.currentSlide = n.options.initialSlide), n.refresh(t), (r = s)),
                        t || !1 === r || n.$slider.trigger("breakpoint", [n, r]);
                }
            }),
            (r.prototype.changeSlide = function (t, e) {
                var i,
                    s,
                    o = this,
                    n = c(t.currentTarget);
                switch ((n.is("a") && t.preventDefault(), n.is("li") || (n = n.closest("li")), (i = o.slideCount % o.options.slidesToScroll != 0 ? 0 : (o.slideCount - o.currentSlide) % o.options.slidesToScroll), t.data.message)) {
                    case "previous":
                        (s = 0 === i ? o.options.slidesToScroll : o.options.slidesToShow - i), o.slideCount > o.options.slidesToShow && o.slideHandler(o.currentSlide - s, !1, e);
                        break;
                    case "next":
                        (s = 0 === i ? o.options.slidesToScroll : i), o.slideCount > o.options.slidesToShow && o.slideHandler(o.currentSlide + s, !1, e);
                        break;
                    case "index":
                        var r = 0 === t.data.index ? 0 : t.data.index || n.index() * o.options.slidesToScroll;
                        o.slideHandler(o.checkNavigable(r), !1, e), n.children().trigger("focus");
                        break;
                    default:
                        return;
                }
            }),
            (r.prototype.checkNavigable = function (t) {
                var e, i;
                if (((i = 0), t > (e = this.getNavigableIndexes())[e.length - 1])) t = e[e.length - 1];
                else
                    for (var s in e) {
                        if (t < e[s]) {
                            t = i;
                            break;
                        }
                        i = e[s];
                    }
                return t;
            }),
            (r.prototype.cleanUpEvents = function () {
                var t = this;
                t.options.dots && null !== t.$dots && c("li", t.$dots).off("click.slick", t.changeSlide).off("mouseenter.slick", c.proxy(t.interrupt, t, !0)).off("mouseleave.slick", c.proxy(t.interrupt, t, !1)),
                    t.$slider.off("focus.slick blur.slick"),
                    !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow && t.$prevArrow.off("click.slick", t.changeSlide), t.$nextArrow && t.$nextArrow.off("click.slick", t.changeSlide)),
                    t.$list.off("touchstart.slick mousedown.slick", t.swipeHandler),
                    t.$list.off("touchmove.slick mousemove.slick", t.swipeHandler),
                    t.$list.off("touchend.slick mouseup.slick", t.swipeHandler),
                    t.$list.off("touchcancel.slick mouseleave.slick", t.swipeHandler),
                    t.$list.off("click.slick", t.clickHandler),
                    c(document).off(t.visibilityChange, t.visibility),
                    t.cleanUpSlideEvents(),
                    !0 === t.options.accessibility && t.$list.off("keydown.slick", t.keyHandler),
                    !0 === t.options.focusOnSelect && c(t.$slideTrack).children().off("click.slick", t.selectHandler),
                    c(window).off("orientationchange.slick.slick-" + t.instanceUid, t.orientationChange),
                    c(window).off("resize.slick.slick-" + t.instanceUid, t.resize),
                    c("[draggable!=true]", t.$slideTrack).off("dragstart", t.preventDefault),
                    c(window).off("load.slick.slick-" + t.instanceUid, t.setPosition),
                    c(document).off("ready.slick.slick-" + t.instanceUid, t.setPosition);
            }),
            (r.prototype.cleanUpSlideEvents = function () {
                var t = this;
                t.$list.off("mouseenter.slick", c.proxy(t.interrupt, t, !0)), t.$list.off("mouseleave.slick", c.proxy(t.interrupt, t, !1));
            }),
            (r.prototype.cleanUpRows = function () {
                var t;
                1 < this.options.rows && ((t = this.$slides.children().children()).removeAttr("style"), this.$slider.empty().append(t));
            }),
            (r.prototype.clickHandler = function (t) {
                !1 === this.shouldClick && (t.stopImmediatePropagation(), t.stopPropagation(), t.preventDefault());
            }),
            (r.prototype.destroy = function (t) {
                var e = this;
                e.autoPlayClear(),
                    (e.touchObject = {}),
                    e.cleanUpEvents(),
                    c(".slick-cloned", e.$slider).detach(),
                    e.$dots && e.$dots.remove(),
                    e.$prevArrow &&
                        e.$prevArrow.length &&
                        (e.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove()),
                    e.$nextArrow &&
                        e.$nextArrow.length &&
                        (e.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove()),
                    e.$slides &&
                        (e.$slides
                            .removeClass("slick-slide slick-active slick-center slick-visible slick-current")
                            .removeAttr("aria-hidden")
                            .removeAttr("data-slick-index")
                            .each(function () {
                                c(this).attr("style", c(this).data("originalStyling"));
                            }),
                        e.$slideTrack.children(this.options.slide).detach(),
                        e.$slideTrack.detach(),
                        e.$list.detach(),
                        e.$slider.append(e.$slides)),
                    e.cleanUpRows(),
                    e.$slider.removeClass("slick-slider"),
                    e.$slider.removeClass("slick-initialized"),
                    e.$slider.removeClass("slick-dotted"),
                    (e.unslicked = !0),
                    t || e.$slider.trigger("destroy", [e]);
            }),
            (r.prototype.disableTransition = function (t) {
                var e = {};
                (e[this.transitionType] = ""), !1 === this.options.fade ? this.$slideTrack.css(e) : this.$slides.eq(t).css(e);
            }),
            (r.prototype.fadeSlide = function (t, e) {
                var i = this;
                !1 === i.cssTransitions
                    ? (i.$slides.eq(t).css({ zIndex: i.options.zIndex }), i.$slides.eq(t).animate({ opacity: 1 }, i.options.speed, i.options.easing, e))
                    : (i.applyTransition(t),
                      i.$slides.eq(t).css({ opacity: 1, zIndex: i.options.zIndex }),
                      e &&
                          setTimeout(function () {
                              i.disableTransition(t), e.call();
                          }, i.options.speed));
            }),
            (r.prototype.fadeSlideOut = function (t) {
                var e = this;
                !1 === e.cssTransitions ? e.$slides.eq(t).animate({ opacity: 0, zIndex: e.options.zIndex - 2 }, e.options.speed, e.options.easing) : (e.applyTransition(t), e.$slides.eq(t).css({ opacity: 0, zIndex: e.options.zIndex - 2 }));
            }),
            (r.prototype.filterSlides = r.prototype.slickFilter = function (t) {
                var e = this;
                null !== t && ((e.$slidesCache = e.$slides), e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(t).appendTo(e.$slideTrack), e.reinit());
            }),
            (r.prototype.focusHandler = function () {
                var i = this;
                i.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*:not(.slick-arrow)", function (t) {
                    t.stopImmediatePropagation();
                    var e = c(this);
                    setTimeout(function () {
                        i.options.pauseOnFocus && ((i.focussed = e.is(":focus")), i.autoPlay());
                    }, 0);
                });
            }),
            (r.prototype.getCurrent = r.prototype.slickCurrentSlide = function () {
                return this.currentSlide;
            }),
            (r.prototype.getDotCount = function () {
                var t = this,
                    e = 0,
                    i = 0,
                    s = 0;
                if (!0 === t.options.infinite) for (; e < t.slideCount; ) ++s, (e = i + t.options.slidesToScroll), (i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow);
                else if (!0 === t.options.centerMode) s = t.slideCount;
                else if (t.options.asNavFor) for (; e < t.slideCount; ) ++s, (e = i + t.options.slidesToScroll), (i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow);
                else s = 1 + Math.ceil((t.slideCount - t.options.slidesToShow) / t.options.slidesToScroll);
                return s - 1;
            }),
            (r.prototype.getLeft = function (t) {
                var e,
                    i,
                    s,
                    o = this,
                    n = 0;
                return (
                    (o.slideOffset = 0),
                    (i = o.$slides.first().outerHeight(!0)),
                    !0 === o.options.infinite
                        ? (o.slideCount > o.options.slidesToShow && ((o.slideOffset = o.slideWidth * o.options.slidesToShow * -1), (n = i * o.options.slidesToShow * -1)),
                          o.slideCount % o.options.slidesToScroll != 0 &&
                              t + o.options.slidesToScroll > o.slideCount &&
                              o.slideCount > o.options.slidesToShow &&
                              (t > o.slideCount
                                  ? ((o.slideOffset = (o.options.slidesToShow - (t - o.slideCount)) * o.slideWidth * -1), (n = (o.options.slidesToShow - (t - o.slideCount)) * i * -1))
                                  : ((o.slideOffset = (o.slideCount % o.options.slidesToScroll) * o.slideWidth * -1), (n = (o.slideCount % o.options.slidesToScroll) * i * -1))))
                        : t + o.options.slidesToShow > o.slideCount && ((o.slideOffset = (t + o.options.slidesToShow - o.slideCount) * o.slideWidth), (n = (t + o.options.slidesToShow - o.slideCount) * i)),
                    o.slideCount <= o.options.slidesToShow && (n = o.slideOffset = 0),
                    !0 === o.options.centerMode && !0 === o.options.infinite
                        ? (o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2) - o.slideWidth)
                        : !0 === o.options.centerMode && ((o.slideOffset = 0), (o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2))),
                    (e = !1 === o.options.vertical ? t * o.slideWidth * -1 + o.slideOffset : t * i * -1 + n),
                    !0 === o.options.variableWidth &&
                        ((s = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(t) : o.$slideTrack.children(".slick-slide").eq(t + o.options.slidesToShow)),
                        (e = !0 === o.options.rtl ? (s[0] ? -1 * (o.$slideTrack.width() - s[0].offsetLeft - s.width()) : 0) : s[0] ? -1 * s[0].offsetLeft : 0),
                        !0 === o.options.centerMode &&
                            ((s = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(t) : o.$slideTrack.children(".slick-slide").eq(t + o.options.slidesToShow + 1)),
                            (e = !0 === o.options.rtl ? (s[0] ? -1 * (o.$slideTrack.width() - s[0].offsetLeft - s.width()) : 0) : s[0] ? -1 * s[0].offsetLeft : 0),
                            (e += (o.$list.width() - s.outerWidth()) / 2))),
                    e
                );
            }),
            (r.prototype.getOption = r.prototype.slickGetOption = function (t) {
                return this.options[t];
            }),
            (r.prototype.getNavigableIndexes = function () {
                var t,
                    e = this,
                    i = 0,
                    s = 0,
                    o = [];
                for (!1 === e.options.infinite ? (t = e.slideCount) : ((i = -1 * e.options.slidesToScroll), (s = -1 * e.options.slidesToScroll), (t = 2 * e.slideCount)); i < t; )
                    o.push(i), (i = s + e.options.slidesToScroll), (s += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow);
                return o;
            }),
            (r.prototype.getSlick = function () {
                return this;
            }),
            (r.prototype.getSlideCount = function () {
                var i,
                    s,
                    o = this;
                return (
                    (s = !0 === o.options.centerMode ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0),
                    !0 === o.options.swipeToSlide
                        ? (o.$slideTrack.find(".slick-slide").each(function (t, e) {
                              return e.offsetLeft - s + c(e).outerWidth() / 2 > -1 * o.swipeLeft ? ((i = e), !1) : void 0;
                          }),
                          Math.abs(c(i).attr("data-slick-index") - o.currentSlide) || 1)
                        : o.options.slidesToScroll
                );
            }),
            (r.prototype.goTo = r.prototype.slickGoTo = function (t, e) {
                this.changeSlide({ data: { message: "index", index: parseInt(t) } }, e);
            }),
            (r.prototype.init = function (t) {
                var e = this;
                c(e.$slider).hasClass("slick-initialized") ||
                    (c(e.$slider).addClass("slick-initialized"), e.buildRows(), e.buildOut(), e.setProps(), e.startLoad(), e.loadSlider(), e.initializeEvents(), e.updateArrows(), e.updateDots(), e.checkResponsive(!0), e.focusHandler()),
                    t && e.$slider.trigger("init", [e]),
                    !0 === e.options.accessibility && e.initADA(),
                    e.options.autoplay && ((e.paused = !1), e.autoPlay());
            }),
            (r.prototype.initADA = function () {
                var e = this;
                e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({ "aria-hidden": "true", tabindex: "-1" }).find("a, input, button, select").attr({ tabindex: "-1" }),
                    e.$slideTrack.attr("role", "listbox"),
                    e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function (t) {
                        c(this).attr({ role: "option", "aria-describedby": "slick-slide" + e.instanceUid + t });
                    }),
                    null !== e.$dots &&
                        e.$dots
                            .attr("role", "tablist")
                            .find("li")
                            .each(function (t) {
                                c(this).attr({ role: "presentation", "aria-selected": "false", "aria-controls": "navigation" + e.instanceUid + t, id: "slick-slide" + e.instanceUid + t });
                            })
                            .first()
                            .attr("aria-selected", "true")
                            .end()
                            .find("button")
                            .attr("role", "button")
                            .end()
                            .closest("div")
                            .attr("role", "toolbar"),
                    e.activateADA();
            }),
            (r.prototype.initArrowEvents = function () {
                var t = this;
                !0 === t.options.arrows &&
                    t.slideCount > t.options.slidesToShow &&
                    (t.$prevArrow.off("click.slick").on("click.slick", { message: "previous" }, t.changeSlide), t.$nextArrow.off("click.slick").on("click.slick", { message: "next" }, t.changeSlide));
            }),
            (r.prototype.initDotEvents = function () {
                var t = this;
                !0 === t.options.dots && t.slideCount > t.options.slidesToShow && c("li", t.$dots).on("click.slick", { message: "index" }, t.changeSlide),
                    !0 === t.options.dots && !0 === t.options.pauseOnDotsHover && c("li", t.$dots).on("mouseenter.slick", c.proxy(t.interrupt, t, !0)).on("mouseleave.slick", c.proxy(t.interrupt, t, !1));
            }),
            (r.prototype.initSlideEvents = function () {
                var t = this;
                t.options.pauseOnHover && (t.$list.on("mouseenter.slick", c.proxy(t.interrupt, t, !0)), t.$list.on("mouseleave.slick", c.proxy(t.interrupt, t, !1)));
            }),
            (r.prototype.initializeEvents = function () {
                var t = this;
                t.initArrowEvents(),
                    t.initDotEvents(),
                    t.initSlideEvents(),
                    t.$list.on("touchstart.slick mousedown.slick", { action: "start" }, t.swipeHandler),
                    t.$list.on("touchmove.slick mousemove.slick", { action: "move" }, t.swipeHandler),
                    t.$list.on("touchend.slick mouseup.slick", { action: "end" }, t.swipeHandler),
                    t.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, t.swipeHandler),
                    t.$list.on("click.slick", t.clickHandler),
                    c(document).on(t.visibilityChange, c.proxy(t.visibility, t)),
                    !0 === t.options.accessibility && t.$list.on("keydown.slick", t.keyHandler),
                    !0 === t.options.focusOnSelect && c(t.$slideTrack).children().on("click.slick", t.selectHandler),
                    c(window).on("orientationchange.slick.slick-" + t.instanceUid, c.proxy(t.orientationChange, t)),
                    c(window).on("resize.slick.slick-" + t.instanceUid, c.proxy(t.resize, t)),
                    c("[draggable!=true]", t.$slideTrack).on("dragstart", t.preventDefault),
                    c(window).on("load.slick.slick-" + t.instanceUid, t.setPosition),
                    c(document).on("ready.slick.slick-" + t.instanceUid, t.setPosition);
            }),
            (r.prototype.initUI = function () {
                var t = this;
                !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow.show(), t.$nextArrow.show()), !0 === t.options.dots && t.slideCount > t.options.slidesToShow && t.$dots.show();
            }),
            (r.prototype.keyHandler = function (t) {
                var e = this;
                t.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
                    (37 === t.keyCode && !0 === e.options.accessibility
                        ? e.changeSlide({ data: { message: !0 === e.options.rtl ? "next" : "previous" } })
                        : 39 === t.keyCode && !0 === e.options.accessibility && e.changeSlide({ data: { message: !0 === e.options.rtl ? "previous" : "next" } }));
            }),
            (r.prototype.lazyLoad = function () {
                function t(t) {
                    c("img[data-lazy]", t).each(function () {
                        var t = c(this),
                            e = c(this).attr("data-lazy"),
                            i = document.createElement("img");
                        (i.onload = function () {
                            t.animate({ opacity: 0 }, 100, function () {
                                t.attr("src", e).animate({ opacity: 1 }, 200, function () {
                                    t.removeAttr("data-lazy").removeClass("slick-loading");
                                }),
                                    s.$slider.trigger("lazyLoaded", [s, t, e]);
                            });
                        }),
                            (i.onerror = function () {
                                t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), s.$slider.trigger("lazyLoadError", [s, t, e]);
                            }),
                            (i.src = e);
                    });
                }
                var e,
                    i,
                    s = this;
                !0 === s.options.centerMode
                    ? !0 === s.options.infinite
                        ? (i = (e = s.currentSlide + (s.options.slidesToShow / 2 + 1)) + s.options.slidesToShow + 2)
                        : ((e = Math.max(0, s.currentSlide - (s.options.slidesToShow / 2 + 1))), (i = s.options.slidesToShow / 2 + 1 + 2 + s.currentSlide))
                    : ((e = s.options.infinite ? s.options.slidesToShow + s.currentSlide : s.currentSlide), (i = Math.ceil(e + s.options.slidesToShow)), !0 === s.options.fade && (0 < e && e--, i <= s.slideCount && i++)),
                    t(s.$slider.find(".slick-slide").slice(e, i)),
                    s.slideCount <= s.options.slidesToShow
                        ? t(s.$slider.find(".slick-slide"))
                        : s.currentSlide >= s.slideCount - s.options.slidesToShow
                        ? t(s.$slider.find(".slick-cloned").slice(0, s.options.slidesToShow))
                        : 0 === s.currentSlide && t(s.$slider.find(".slick-cloned").slice(-1 * s.options.slidesToShow));
            }),
            (r.prototype.loadSlider = function () {
                var t = this;
                t.setPosition(), t.$slideTrack.css({ opacity: 1 }), t.$slider.removeClass("slick-loading"), t.initUI(), "progressive" === t.options.lazyLoad && t.progressiveLazyLoad();
            }),
            (r.prototype.next = r.prototype.slickNext = function () {
                this.changeSlide({ data: { message: "next" } });
            }),
            (r.prototype.orientationChange = function () {
                this.checkResponsive(), this.setPosition();
            }),
            (r.prototype.pause = r.prototype.slickPause = function () {
                this.autoPlayClear(), (this.paused = !0);
            }),
            (r.prototype.play = r.prototype.slickPlay = function () {
                var t = this;
                t.autoPlay(), (t.options.autoplay = !0), (t.paused = !1), (t.focussed = !1), (t.interrupted = !1);
            }),
            (r.prototype.postSlide = function (t) {
                var e = this;
                e.unslicked || (e.$slider.trigger("afterChange", [e, t]), (e.animating = !1), e.setPosition(), (e.swipeLeft = null), e.options.autoplay && e.autoPlay(), !0 === e.options.accessibility && e.initADA());
            }),
            (r.prototype.prev = r.prototype.slickPrev = function () {
                this.changeSlide({ data: { message: "previous" } });
            }),
            (r.prototype.preventDefault = function (t) {
                t.preventDefault();
            }),
            (r.prototype.progressiveLazyLoad = function (t) {
                t = t || 1;
                var e,
                    i,
                    s,
                    o = this,
                    n = c("img[data-lazy]", o.$slider);
                n.length
                    ? ((e = n.first()),
                      (i = e.attr("data-lazy")),
                      ((s = document.createElement("img")).onload = function () {
                          e.attr("src", i).removeAttr("data-lazy").removeClass("slick-loading"), !0 === o.options.adaptiveHeight && o.setPosition(), o.$slider.trigger("lazyLoaded", [o, e, i]), o.progressiveLazyLoad();
                      }),
                      (s.onerror = function () {
                          t < 3
                              ? setTimeout(function () {
                                    o.progressiveLazyLoad(t + 1);
                                }, 500)
                              : (e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), o.$slider.trigger("lazyLoadError", [o, e, i]), o.progressiveLazyLoad());
                      }),
                      (s.src = i))
                    : o.$slider.trigger("allImagesLoaded", [o]);
            }),
            (r.prototype.refresh = function (t) {
                var e,
                    i,
                    s = this;
                (i = s.slideCount - s.options.slidesToShow),
                    !s.options.infinite && s.currentSlide > i && (s.currentSlide = i),
                    s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0),
                    (e = s.currentSlide),
                    s.destroy(!0),
                    c.extend(s, s.initials, { currentSlide: e }),
                    s.init(),
                    t || s.changeSlide({ data: { message: "index", index: e } }, !1);
            }),
            (r.prototype.registerBreakpoints = function () {
                var t,
                    e,
                    i,
                    s = this,
                    o = s.options.responsive || null;
                if ("array" === c.type(o) && o.length) {
                    for (t in ((s.respondTo = s.options.respondTo || "window"), o))
                        if (((i = s.breakpoints.length - 1), (e = o[t].breakpoint), o.hasOwnProperty(t))) {
                            for (; 0 <= i; ) s.breakpoints[i] && s.breakpoints[i] === e && s.breakpoints.splice(i, 1), i--;
                            s.breakpoints.push(e), (s.breakpointSettings[e] = o[t].settings);
                        }
                    s.breakpoints.sort(function (t, e) {
                        return s.options.mobileFirst ? t - e : e - t;
                    });
                }
            }),
            (r.prototype.reinit = function () {
                var t = this;
                (t.$slides = t.$slideTrack.children(t.options.slide).addClass("slick-slide")),
                    (t.slideCount = t.$slides.length),
                    t.currentSlide >= t.slideCount && 0 !== t.currentSlide && (t.currentSlide = t.currentSlide - t.options.slidesToScroll),
                    t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0),
                    t.registerBreakpoints(),
                    t.setProps(),
                    t.setupInfinite(),
                    t.buildArrows(),
                    t.updateArrows(),
                    t.initArrowEvents(),
                    t.buildDots(),
                    t.updateDots(),
                    t.initDotEvents(),
                    t.cleanUpSlideEvents(),
                    t.initSlideEvents(),
                    t.checkResponsive(!1, !0),
                    !0 === t.options.focusOnSelect && c(t.$slideTrack).children().on("click.slick", t.selectHandler),
                    t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0),
                    t.setPosition(),
                    t.focusHandler(),
                    (t.paused = !t.options.autoplay),
                    t.autoPlay(),
                    t.$slider.trigger("reInit", [t]);
            }),
            (r.prototype.resize = function () {
                var t = this;
                c(window).width() !== t.windowWidth &&
                    (clearTimeout(t.windowDelay),
                    (t.windowDelay = window.setTimeout(function () {
                        (t.windowWidth = c(window).width()), t.checkResponsive(), t.unslicked || t.setPosition();
                    }, 50)));
            }),
            (r.prototype.removeSlide = r.prototype.slickRemove = function (t, e, i) {
                var s = this;
                return (
                    (t = "boolean" == typeof t ? (!0 === (e = t) ? 0 : s.slideCount - 1) : !0 === e ? --t : t),
                    !(s.slideCount < 1 || t < 0 || t > s.slideCount - 1) &&
                        (s.unload(),
                        !0 === i ? s.$slideTrack.children().remove() : s.$slideTrack.children(this.options.slide).eq(t).remove(),
                        (s.$slides = s.$slideTrack.children(this.options.slide)),
                        s.$slideTrack.children(this.options.slide).detach(),
                        s.$slideTrack.append(s.$slides),
                        (s.$slidesCache = s.$slides),
                        void s.reinit())
                );
            }),
            (r.prototype.setCSS = function (t) {
                var e,
                    i,
                    s = this,
                    o = {};
                !0 === s.options.rtl && (t = -t),
                    (e = "left" == s.positionProp ? Math.ceil(t) + "px" : "0px"),
                    (i = "top" == s.positionProp ? Math.ceil(t) + "px" : "0px"),
                    (o[s.positionProp] = t),
                    !1 === s.transformsEnabled || (!(o = {}) === s.cssTransitions ? (o[s.animType] = "translate(" + e + ", " + i + ")") : (o[s.animType] = "translate3d(" + e + ", " + i + ", 0px)")),
                    s.$slideTrack.css(o);
            }),
            (r.prototype.setDimensions = function () {
                var t = this;
                !1 === t.options.vertical
                    ? !0 === t.options.centerMode && t.$list.css({ padding: "0px " + t.options.centerPadding })
                    : (t.$list.height(t.$slides.first().outerHeight(!0) * t.options.slidesToShow), !0 === t.options.centerMode && t.$list.css({ padding: t.options.centerPadding + " 0px" })),
                    (t.listWidth = t.$list.width()),
                    (t.listHeight = t.$list.height()),
                    !1 === t.options.vertical && !1 === t.options.variableWidth
                        ? ((t.slideWidth = Math.ceil(t.listWidth / t.options.slidesToShow)), t.$slideTrack.width(Math.ceil(t.slideWidth * t.$slideTrack.children(".slick-slide").length)))
                        : !0 === t.options.variableWidth
                        ? t.$slideTrack.width(5e3 * t.slideCount)
                        : ((t.slideWidth = Math.ceil(t.listWidth)), t.$slideTrack.height(Math.ceil(t.$slides.first().outerHeight(!0) * t.$slideTrack.children(".slick-slide").length)));
                var e = t.$slides.first().outerWidth(!0) - t.$slides.first().width();
                !1 === t.options.variableWidth && t.$slideTrack.children(".slick-slide").width(t.slideWidth - e);
            }),
            (r.prototype.setFade = function () {
                var i,
                    s = this;
                s.$slides.each(function (t, e) {
                    (i = s.slideWidth * t * -1),
                        !0 === s.options.rtl ? c(e).css({ position: "relative", right: i, top: 0, zIndex: s.options.zIndex - 2, opacity: 0 }) : c(e).css({ position: "relative", left: i, top: 0, zIndex: s.options.zIndex - 2, opacity: 0 });
                }),
                    s.$slides.eq(s.currentSlide).css({ zIndex: s.options.zIndex - 1, opacity: 1 });
            }),
            (r.prototype.setHeight = function () {
                var t = this;
                if (1 === t.options.slidesToShow && !0 === t.options.adaptiveHeight && !1 === t.options.vertical) {
                    var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
                    t.$list.css("height", e);
                }
            }),
            (r.prototype.setOption = r.prototype.slickSetOption = function () {
                var t,
                    e,
                    i,
                    s,
                    o,
                    n = this,
                    r = !1;
                if (
                    ("object" === c.type(arguments[0])
                        ? ((i = arguments[0]), (r = arguments[1]), (o = "multiple"))
                        : "string" === c.type(arguments[0]) &&
                          ((i = arguments[0]), (s = arguments[1]), (r = arguments[2]), "responsive" === arguments[0] && "array" === c.type(arguments[1]) ? (o = "responsive") : void 0 !== arguments[1] && (o = "single")),
                    "single" === o)
                )
                    n.options[i] = s;
                else if ("multiple" === o)
                    c.each(i, function (t, e) {
                        n.options[t] = e;
                    });
                else if ("responsive" === o)
                    for (e in s)
                        if ("array" !== c.type(n.options.responsive)) n.options.responsive = [s[e]];
                        else {
                            for (t = n.options.responsive.length - 1; 0 <= t; ) n.options.responsive[t].breakpoint === s[e].breakpoint && n.options.responsive.splice(t, 1), t--;
                            n.options.responsive.push(s[e]);
                        }
                r && (n.unload(), n.reinit());
            }),
            (r.prototype.setPosition = function () {
                var t = this;
                t.setDimensions(), t.setHeight(), !1 === t.options.fade ? t.setCSS(t.getLeft(t.currentSlide)) : t.setFade(), t.$slider.trigger("setPosition", [t]);
            }),
            (r.prototype.setProps = function () {
                var t = this,
                    e = document.body.style;
                (t.positionProp = !0 === t.options.vertical ? "top" : "left"),
                    "top" === t.positionProp ? t.$slider.addClass("slick-vertical") : t.$slider.removeClass("slick-vertical"),
                    (void 0 !== e.WebkitTransition || void 0 !== e.MozTransition || void 0 !== e.msTransition) && !0 === t.options.useCSS && (t.cssTransitions = !0),
                    t.options.fade && ("number" == typeof t.options.zIndex ? t.options.zIndex < 3 && (t.options.zIndex = 3) : (t.options.zIndex = t.defaults.zIndex)),
                    void 0 !== e.OTransform && ((t.animType = "OTransform"), (t.transformType = "-o-transform"), (t.transitionType = "OTransition"), void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (t.animType = !1)),
                    void 0 !== e.MozTransform &&
                        ((t.animType = "MozTransform"), (t.transformType = "-moz-transform"), (t.transitionType = "MozTransition"), void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (t.animType = !1)),
                    void 0 !== e.webkitTransform &&
                        ((t.animType = "webkitTransform"), (t.transformType = "-webkit-transform"), (t.transitionType = "webkitTransition"), void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (t.animType = !1)),
                    void 0 !== e.msTransform && ((t.animType = "msTransform"), (t.transformType = "-ms-transform"), (t.transitionType = "msTransition"), void 0 === e.msTransform && (t.animType = !1)),
                    void 0 !== e.transform && !1 !== t.animType && ((t.animType = "transform"), (t.transformType = "transform"), (t.transitionType = "transition")),
                    (t.transformsEnabled = t.options.useTransform && null !== t.animType && !1 !== t.animType);
            }),
            (r.prototype.setSlideClasses = function (t) {
                var e,
                    i,
                    s,
                    o,
                    n = this;
                (i = n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true")),
                    n.$slides.eq(t).addClass("slick-current"),
                    !0 === n.options.centerMode
                        ? ((e = Math.floor(n.options.slidesToShow / 2)),
                          !0 === n.options.infinite &&
                              (e <= t && t <= n.slideCount - 1 - e
                                  ? n.$slides
                                        .slice(t - e, t + e + 1)
                                        .addClass("slick-active")
                                        .attr("aria-hidden", "false")
                                  : ((s = n.options.slidesToShow + t),
                                    i
                                        .slice(s - e + 1, s + e + 2)
                                        .addClass("slick-active")
                                        .attr("aria-hidden", "false")),
                              0 === t ? i.eq(i.length - 1 - n.options.slidesToShow).addClass("slick-center") : t === n.slideCount - 1 && i.eq(n.options.slidesToShow).addClass("slick-center")),
                          n.$slides.eq(t).addClass("slick-center"))
                        : 0 <= t && t <= n.slideCount - n.options.slidesToShow
                        ? n.$slides
                              .slice(t, t + n.options.slidesToShow)
                              .addClass("slick-active")
                              .attr("aria-hidden", "false")
                        : i.length <= n.options.slidesToShow
                        ? i.addClass("slick-active").attr("aria-hidden", "false")
                        : ((o = n.slideCount % n.options.slidesToShow),
                          (s = !0 === n.options.infinite ? n.options.slidesToShow + t : t),
                          n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - t < n.options.slidesToShow
                              ? i
                                    .slice(s - (n.options.slidesToShow - o), s + o)
                                    .addClass("slick-active")
                                    .attr("aria-hidden", "false")
                              : i
                                    .slice(s, s + n.options.slidesToShow)
                                    .addClass("slick-active")
                                    .attr("aria-hidden", "false")),
                    "ondemand" === n.options.lazyLoad && n.lazyLoad();
            }),
            (r.prototype.setupInfinite = function () {
                var t,
                    e,
                    i,
                    s = this;
                if ((!0 === s.options.fade && (s.options.centerMode = !1), !0 === s.options.infinite && !1 === s.options.fade && ((e = null), s.slideCount > s.options.slidesToShow))) {
                    for (i = !0 === s.options.centerMode ? s.options.slidesToShow + 1 : s.options.slidesToShow, t = s.slideCount; t > s.slideCount - i; t -= 1)
                        (e = t - 1),
                            c(s.$slides[e])
                                .clone(!0)
                                .attr("id", "")
                                .attr("data-slick-index", e - s.slideCount)
                                .prependTo(s.$slideTrack)
                                .addClass("slick-cloned");
                    for (t = 0; t < i; t += 1)
                        (e = t),
                            c(s.$slides[e])
                                .clone(!0)
                                .attr("id", "")
                                .attr("data-slick-index", e + s.slideCount)
                                .appendTo(s.$slideTrack)
                                .addClass("slick-cloned");
                    s.$slideTrack
                        .find(".slick-cloned")
                        .find("[id]")
                        .each(function () {
                            c(this).attr("id", "");
                        });
                }
            }),
            (r.prototype.interrupt = function (t) {
                t || this.autoPlay(), (this.interrupted = t);
            }),
            (r.prototype.selectHandler = function (t) {
                var e = this,
                    i = c(t.target).is(".slick-slide") ? c(t.target) : c(t.target).parents(".slick-slide"),
                    s = parseInt(i.attr("data-slick-index"));
                return s || (s = 0), e.slideCount <= e.options.slidesToShow ? (e.setSlideClasses(s), void e.asNavFor(s)) : void e.slideHandler(s);
            }),
            (r.prototype.slideHandler = function (t, e, i) {
                var s,
                    o,
                    n,
                    r,
                    a,
                    l = null,
                    c = this;
                return (
                    (e = e || !1),
                    (!0 === c.animating && !0 === c.options.waitForAnimate) || (!0 === c.options.fade && c.currentSlide === t) || c.slideCount <= c.options.slidesToShow
                        ? void 0
                        : (!1 === e && c.asNavFor(t),
                          (s = t),
                          (l = c.getLeft(s)),
                          (r = c.getLeft(c.currentSlide)),
                          (c.currentLeft = null === c.swipeLeft ? r : c.swipeLeft),
                          !1 === c.options.infinite && !1 === c.options.centerMode && (t < 0 || t > c.getDotCount() * c.options.slidesToScroll)
                              ? void (
                                    !1 === c.options.fade &&
                                    ((s = c.currentSlide),
                                    !0 !== i
                                        ? c.animateSlide(r, function () {
                                              c.postSlide(s);
                                          })
                                        : c.postSlide(s))
                                )
                              : !1 === c.options.infinite && !0 === c.options.centerMode && (t < 0 || t > c.slideCount - c.options.slidesToScroll)
                              ? void (
                                    !1 === c.options.fade &&
                                    ((s = c.currentSlide),
                                    !0 !== i
                                        ? c.animateSlide(r, function () {
                                              c.postSlide(s);
                                          })
                                        : c.postSlide(s))
                                )
                              : (c.options.autoplay && clearInterval(c.autoPlayTimer),
                                (o =
                                    s < 0
                                        ? c.slideCount % c.options.slidesToScroll != 0
                                            ? c.slideCount - (c.slideCount % c.options.slidesToScroll)
                                            : c.slideCount + s
                                        : s >= c.slideCount
                                        ? c.slideCount % c.options.slidesToScroll != 0
                                            ? 0
                                            : s - c.slideCount
                                        : s),
                                (c.animating = !0),
                                c.$slider.trigger("beforeChange", [c, c.currentSlide, o]),
                                (n = c.currentSlide),
                                (c.currentSlide = o),
                                c.setSlideClasses(c.currentSlide),
                                c.options.asNavFor && (a = (a = c.getNavTarget()).slick("getSlick")).slideCount <= a.options.slidesToShow && a.setSlideClasses(c.currentSlide),
                                c.updateDots(),
                                c.updateArrows(),
                                !0 === c.options.fade
                                    ? (!0 !== i
                                          ? (c.fadeSlideOut(n),
                                            c.fadeSlide(o, function () {
                                                c.postSlide(o);
                                            }))
                                          : c.postSlide(o),
                                      void c.animateHeight())
                                    : void (!0 !== i
                                          ? c.animateSlide(l, function () {
                                                c.postSlide(o);
                                            })
                                          : c.postSlide(o))))
                );
            }),
            (r.prototype.startLoad = function () {
                var t = this;
                !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow.hide(), t.$nextArrow.hide()),
                    !0 === t.options.dots && t.slideCount > t.options.slidesToShow && t.$dots.hide(),
                    t.$slider.addClass("slick-loading");
            }),
            (r.prototype.swipeDirection = function () {
                var t,
                    e,
                    i,
                    s,
                    o = this;
                return (
                    (t = o.touchObject.startX - o.touchObject.curX),
                    (e = o.touchObject.startY - o.touchObject.curY),
                    (i = Math.atan2(e, t)),
                    (s = Math.round((180 * i) / Math.PI)) < 0 && (s = 360 - Math.abs(s)),
                    s <= 45 && 0 <= s
                        ? !1 === o.options.rtl
                            ? "left"
                            : "right"
                        : s <= 360 && 315 <= s
                        ? !1 === o.options.rtl
                            ? "left"
                            : "right"
                        : 135 <= s && s <= 225
                        ? !1 === o.options.rtl
                            ? "right"
                            : "left"
                        : !0 === o.options.verticalSwiping
                        ? 35 <= s && s <= 135
                            ? "down"
                            : "up"
                        : "vertical"
                );
            }),
            (r.prototype.swipeEnd = function (t) {
                var e,
                    i,
                    s = this;
                if (((s.dragging = !1), (s.interrupted = !1), (s.shouldClick = !(10 < s.touchObject.swipeLength)), void 0 === s.touchObject.curX)) return !1;
                if ((!0 === s.touchObject.edgeHit && s.$slider.trigger("edge", [s, s.swipeDirection()]), s.touchObject.swipeLength >= s.touchObject.minSwipe)) {
                    switch ((i = s.swipeDirection())) {
                        case "left":
                        case "down":
                            (e = s.options.swipeToSlide ? s.checkNavigable(s.currentSlide + s.getSlideCount()) : s.currentSlide + s.getSlideCount()), (s.currentDirection = 0);
                            break;
                        case "right":
                        case "up":
                            (e = s.options.swipeToSlide ? s.checkNavigable(s.currentSlide - s.getSlideCount()) : s.currentSlide - s.getSlideCount()), (s.currentDirection = 1);
                    }
                    "vertical" != i && (s.slideHandler(e), (s.touchObject = {}), s.$slider.trigger("swipe", [s, i]));
                } else s.touchObject.startX !== s.touchObject.curX && (s.slideHandler(s.currentSlide), (s.touchObject = {}));
            }),
            (r.prototype.swipeHandler = function (t) {
                var e = this;
                if (!(!1 === e.options.swipe || ("ontouchend" in document && !1 === e.options.swipe) || (!1 === e.options.draggable && -1 !== t.type.indexOf("mouse"))))
                    switch (
                        ((e.touchObject.fingerCount = t.originalEvent && void 0 !== t.originalEvent.touches ? t.originalEvent.touches.length : 1),
                        (e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold),
                        !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold),
                        t.data.action)
                    ) {
                        case "start":
                            e.swipeStart(t);
                            break;
                        case "move":
                            e.swipeMove(t);
                            break;
                        case "end":
                            e.swipeEnd(t);
                    }
            }),
            (r.prototype.swipeMove = function (t) {
                var e,
                    i,
                    s,
                    o,
                    n,
                    r = this;
                return (
                    (n = void 0 !== t.originalEvent ? t.originalEvent.touches : null),
                    !(!r.dragging || (n && 1 !== n.length)) &&
                        ((e = r.getLeft(r.currentSlide)),
                        (r.touchObject.curX = void 0 !== n ? n[0].pageX : t.clientX),
                        (r.touchObject.curY = void 0 !== n ? n[0].pageY : t.clientY),
                        (r.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(r.touchObject.curX - r.touchObject.startX, 2)))),
                        !0 === r.options.verticalSwiping && (r.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(r.touchObject.curY - r.touchObject.startY, 2)))),
                        "vertical" !== (i = r.swipeDirection())
                            ? (void 0 !== t.originalEvent && 4 < r.touchObject.swipeLength && t.preventDefault(),
                              (o = (!1 === r.options.rtl ? 1 : -1) * (r.touchObject.curX > r.touchObject.startX ? 1 : -1)),
                              !0 === r.options.verticalSwiping && (o = r.touchObject.curY > r.touchObject.startY ? 1 : -1),
                              (s = r.touchObject.swipeLength),
                              (r.touchObject.edgeHit = !1) === r.options.infinite &&
                                  ((0 === r.currentSlide && "right" === i) || (r.currentSlide >= r.getDotCount() && "left" === i)) &&
                                  ((s = r.touchObject.swipeLength * r.options.edgeFriction), (r.touchObject.edgeHit = !0)),
                              !1 === r.options.vertical ? (r.swipeLeft = e + s * o) : (r.swipeLeft = e + s * (r.$list.height() / r.listWidth) * o),
                              !0 === r.options.verticalSwiping && (r.swipeLeft = e + s * o),
                              !0 !== r.options.fade && !1 !== r.options.touchMove && (!0 === r.animating ? ((r.swipeLeft = null), !1) : void r.setCSS(r.swipeLeft)))
                            : void 0)
                );
            }),
            (r.prototype.swipeStart = function (t) {
                var e,
                    i = this;
                return (
                    (i.interrupted = !0),
                    1 !== i.touchObject.fingerCount || i.slideCount <= i.options.slidesToShow
                        ? !(i.touchObject = {})
                        : (void 0 !== t.originalEvent && void 0 !== t.originalEvent.touches && (e = t.originalEvent.touches[0]),
                          (i.touchObject.startX = i.touchObject.curX = void 0 !== e ? e.pageX : t.clientX),
                          (i.touchObject.startY = i.touchObject.curY = void 0 !== e ? e.pageY : t.clientY),
                          void (i.dragging = !0))
                );
            }),
            (r.prototype.unfilterSlides = r.prototype.slickUnfilter = function () {
                var t = this;
                null !== t.$slidesCache && (t.unload(), t.$slideTrack.children(this.options.slide).detach(), t.$slidesCache.appendTo(t.$slideTrack), t.reinit());
            }),
            (r.prototype.unload = function () {
                var t = this;
                c(".slick-cloned", t.$slider).remove(),
                    t.$dots && t.$dots.remove(),
                    t.$prevArrow && t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove(),
                    t.$nextArrow && t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove(),
                    t.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "");
            }),
            (r.prototype.unslick = function (t) {
                this.$slider.trigger("unslick", [this, t]), this.destroy();
            }),
            (r.prototype.updateArrows = function () {
                var t = this;
                Math.floor(t.options.slidesToShow / 2),
                    !0 === t.options.arrows &&
                        t.slideCount > t.options.slidesToShow &&
                        !t.options.infinite &&
                        (t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                        t.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                        0 === t.currentSlide
                            ? (t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), t.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))
                            : t.currentSlide >= t.slideCount - t.options.slidesToShow && !1 === t.options.centerMode
                            ? (t.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))
                            : t.currentSlide >= t.slideCount - 1 &&
                              !0 === t.options.centerMode &&
                              (t.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")));
            }),
            (r.prototype.updateDots = function () {
                var t = this;
                null !== t.$dots &&
                    (t.$dots.find("li").removeClass("slick-active").attr("aria-hidden", "true"),
                    t.$dots
                        .find("li")
                        .eq(Math.floor(t.currentSlide / t.options.slidesToScroll))
                        .addClass("slick-active")
                        .attr("aria-hidden", "false"));
            }),
            (r.prototype.visibility = function () {
                this.options.autoplay && (document[this.hidden] ? (this.interrupted = !0) : (this.interrupted = !1));
            }),
            (c.fn.slick = function () {
                var t,
                    e,
                    i = this,
                    s = arguments[0],
                    o = Array.prototype.slice.call(arguments, 1),
                    n = i.length;
                for (t = 0; t < n; t++) if (("object" == typeof s || void 0 === s ? (i[t].slick = new r(i[t], s)) : (e = i[t].slick[s].apply(i[t].slick, o)), void 0 !== e)) return e;
                return i;
            });
    }),
    (function (u) {
        u.fn.ondemand = function (l) {
            (l = u.extend(
                {},
                {
                    url: "",
                    site: "",
                    siteId: "",
                    titleWidget: "Live from auctions",
                    primaryColor: "#000",
                    secondaryColor: "#ccc",
                    background: "#fff",
                    parameters: "",
                    rc: "10",
                    utmString: "",
                    rotationSpeed: 5e3,
                    template: "source",
                    sslImg: !1,
                    carousel: !0,
                    items: 5,
                    liveUpdate: !1,
                    dev: !1,
                    verbose: !1,
                    allItemsAction: "allAuction.action",
                    getItemAction: "auctionDisplay.action",
                    countdown: !0,
                },
                l
            )),
                "localhost" === window.location.hostname && (console.log("Dev mode. Using " + l.devRoot + " as a middleman."), (l.dev = !0));
            var c = function (t, e, i, s) {
                    var o = i[t],
                        n = s(o);
                    u(e).addClass("cd-ondemand--active").html(n),
                        u(".cdo-closes").countdown(o.timeLeft, function (t) {
                            u(this).html(t.strftime("<strong>Time left:</strong> %D days %H:%M:%S"));
                        }),
                        t++,
                        (t %= i.length),
                        1 < i.length &&
                            setTimeout(function () {
                                c(t, e, i, s);
                            }, l.rotationSpeed);
                },
                p = u(this),
                t = "?sid=" + l.siteId + "&rc=" + l.items + "&viewType=api&" + l.parameters + "&pgmode1=" + l.sslImg,
                d = l.dev ? l.devRoot + "/getItems.php" + t : l.site + "/iSynApp/" + l.allItemsAction + t,
                h = l.dev ? l.devRoot + "/getAuctionItem.php?auctionId=" : l.site + "/iSynApp/" + l.getItemAction + "?viewType=api&auctionId=";
            l.verbose && console.log(d),
                u.get(d, function (t) {
                    l.dev && (console.log(d), console.log(t));
                    var e;
                    var n = (typeof t === "object") ? t : u.parseJSON(t);
                    if (0 < n.items.length) {
                      for (var i = 0; i < n.items.length; i++)
                            if (
                                ((n.items[i].title = n.items[i].title.replace(/&quot;/g, '"')),
                                (n.items[i].title = n.items[i].title.replace(/&#39;/g, "'")),
                                (n.items[i].url = n.items[i].url + l.utmString),
                                (n.items[i].secondaryColor = l.secondaryColor),
                                (n.items[i].primaryColor = l.primaryColor),
                                void 0 !== n.items[i].closeTime)
                            ) {
                                var s = n.items[i].closeTime,
                                    o = new Date(s.replace(" ", "T") + "Z");
                                n.items[i].timeLeft = (e = o).getFullYear() + "/" + (e.getMonth() + 1) + "/" + e.getDate() + " " + e.getHours() + ":" + e.getMinutes() + ":" + e.getSeconds();
                            }
                        Handlebars.registerHelper("primaryColor", function () {
                            return l.primaryColor;
                        }),
                            Handlebars.registerHelper("secondaryColor", function () {
                                return l.secondaryColor;
                            }),
                            Handlebars.registerHelper("background", function () {
                                return l.background;
                            }),
                            Handlebars.registerHelper("titleWidget", function () {
                                return l.titleWidget;
                            });
                        var r = Handlebars.compile(templates[l.template]);
                        if (l.carousel) {
                            var a = r(n);
                            u(p)
                                .addClass("cd-ondemand--active")
                                .html(a)
                                .find(".cdo-slick")
                                .slick({
                                    slidesToShow: 4,
                                    slidesToScroll: 4,
                                    autoplay: !0,
                                    autoplaySpeed: l.rotationSpeed,
                                    arrows: !0,
                                    responsive: [
                                        { breakpoint: 1410, settings: { slidesToShow: 4, slidesToScroll: 4, infinite: !0 } },
                                        { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3, infinite: !0 } },
                                        { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2 } },
                                        { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
                                    ],
                                })
                                .on("afterChange", function (t, e, i) {
                                    var s = (i + 1) % n.items.length,
                                        o = h + n.items[s].id;
                                    l.liveUpdate &&
                                        u.get(o, function (t) {
                                            console.log(t);
                                            var e = (typeof t === "object") ? t : u.parseJSON(t);
                                            if (e.bidCount !== n.items[s].bidCount) {
                                                var i = "#item-" + n.items[s].id;
                                                console.log("Bid on auction " + n.items[s].id),
                                                    (n.items[s].currentBid = e.currentBid),
                                                    (n.items[s].bidCount = e.bidCount),
                                                    u(i).find(".cdo-current-bid-value").html(n.items[s].currentBid),
                                                    u(i).find(".cdo-bid-count-value").html(n.items[s].bidCount);
                                            }
                                        });
                                }),
                                l.countdown &&
                                    u(".cdo-closes").each(function () {
                                        u(this).countdown(u(this).data("time-left"), function (t) {
                                            u(this).html(t.strftime("<strong>Closes in</strong> %D days %H:%M:%S"));
                                        });
                                    });
                        } else c(0, u(p), n.items, r);
                    } else u(p).remove();
                });
        };
})(jQuery);